/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 923:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var LOCAL_STORAGE_KEY = 'pxu-shopify-surface-pick-up';
var loadingClass = 'surface-pick-up--loading';

var isNotExpired = function isNotExpired(timestamp) {
  return timestamp + 1000 * 60 * 60 >= Date.now();
};

var removeTrailingSlash = function removeTrailingSlash(s) {
  return s.replace(/(.*)\/$/, '$1');
}; // Haversine Distance
// The haversine formula is an equation giving great-circle distances between
// two points on a sphere from their longitudes and latitudes


function calculateDistance(latitude1, longitude1, latitude2, longitude2, unitSystem) {
  var dtor = Math.PI / 180;
  var radius = unitSystem === 'metric' ? 6378.14 : 3959;
  var rlat1 = latitude1 * dtor;
  var rlong1 = longitude1 * dtor;
  var rlat2 = latitude2 * dtor;
  var rlong2 = longitude2 * dtor;
  var dlon = rlong1 - rlong2;
  var dlat = rlat1 - rlat2;
  var a = Math.pow(Math.sin(dlat / 2), 2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.pow(Math.sin(dlon / 2), 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return radius * c;
}

function getGeoLocation() {
  return _getGeoLocation.apply(this, arguments);
}

function _getGeoLocation() {
  _getGeoLocation = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var options = {
                maximumAge: 3600000,
                // 1 hour
                timeout: 5000
              };

              if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (_ref3) {
                  var coords = _ref3.coords;
                  return resolve(coords);
                }, reject, options);
              } else {
                reject();
              }
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getGeoLocation.apply(this, arguments);
}

function setLocation(_x) {
  return _setLocation.apply(this, arguments);
}

function _setLocation() {
  _setLocation = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref) {
    var latitude, longitude, newData;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            latitude = _ref.latitude, longitude = _ref.longitude;
            newData = {
              latitude: latitude,
              longitude: longitude,
              timestamp: Date.now()
            };
            localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newData));
            return _context2.abrupt("return", fetch('/localization.json', {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                latitude: latitude,
                longitude: longitude
              })
            }).then(function () {
              return {
                latitude: latitude,
                longitude: longitude
              };
            }));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _setLocation.apply(this, arguments);
}

function getLocation() {
  return _getLocation.apply(this, arguments);
}

function _getLocation() {
  _getLocation = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var requestLocation,
        cachedLocation,
        _args3 = arguments;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            requestLocation = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : false;
            cachedLocation = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));

            if (!(cachedLocation && isNotExpired(cachedLocation.timestamp))) {
              _context3.next = 4;
              break;
            }

            return _context3.abrupt("return", cachedLocation);

          case 4:
            if (!requestLocation) {
              _context3.next = 6;
              break;
            }

            return _context3.abrupt("return", getGeoLocation().then(function (coords) {
              setLocation(coords); // We don't need to wait for this

              return coords;
            }));

          case 6:
            return _context3.abrupt("return", null);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getLocation.apply(this, arguments);
}

var SurfacePickUp = /*#__PURE__*/function () {
  function SurfacePickUp(el, options) {
    _classCallCheck(this, SurfacePickUp);

    this.el = el;
    this.options = _objectSpread2({
      root_url: window.Theme && window.Theme.routes && window.Theme.routes.root_url || ''
    }, options);
    this.options.root_url = removeTrailingSlash(this.options.root_url);
    this.callbacks = [];
    this.onBtnPress = null;
    this.latestVariantId = null;
  }

  _createClass(SurfacePickUp, [{
    key: "load",
    value: function load(variantId) {
      var _this = this;

      // If no variant is available, empty element and quick-return
      if (!variantId) {
        this.el.innerHTML = '';
        return Promise.resolve(true);
      } // Because Shopify doesn't expose any `pick_up_enabled` data on the shop object, we
      // don't know if the variant might be, or is definitely not available for pick up.
      // Until we know the shop has > 0 pick up locations, we want to avoid prompting the
      // user for location data (it's annoying, and only makes sense to do if we use it).
      //
      // Instead, we have to make an initial request, check and see if any pick up locations
      // were returned, then ask for the users location, then make another request to get the
      // location-aware pick up locations.
      //
      // As far as I can tell the pick up aware locations differ only in sort order - which
      // we could do on the front end - but we're following this approach to ensure future
      // compatibility with any changes Shopify makes (maybe disabling options based on
      // user location, or whatever else).
      //
      // Shopify has indicated they will look into adding pick_up_enabled data to the shop
      // object, which which case this method can be greatly simplifed into 2 simple cases.


      this.latestVariantId = variantId;
      this.el.classList.add(loadingClass);
      return this._getData(variantId).then(function (data) {
        return _this._injectData(data);
      });
    }
  }, {
    key: "onModalRequest",
    value: function onModalRequest(callback) {
      if (this.callbacks.indexOf(callback) >= 0) return;
      this.callbacks.push(callback);
    }
  }, {
    key: "offModalRequest",
    value: function offModalRequest(callback) {
      this.callbacks.splice(this.callbacks.indexOf(callback));
    }
  }, {
    key: "unload",
    value: function unload() {
      this.callbacks = [];
      this.el.innerHTML = '';
    }
  }, {
    key: "_getData",
    value: function _getData(variantId) {
      var _this2 = this;

      return new Promise(function (resolve) {
        var xhr = new XMLHttpRequest();
        var requestUrl = "".concat(_this2.options.root_url, "/variants/").concat(variantId, "/?section_id=surface-pick-up");
        xhr.open('GET', requestUrl, true);

        xhr.onload = function () {
          var el = xhr.response;
          var embed = el.querySelector('[data-html="surface-pick-up-embed"]');
          var itemsContainer = el.querySelector('[data-html="surface-pick-up-items"]');
          var items = itemsContainer.content.querySelectorAll('[data-surface-pick-up-item]');
          resolve({
            embed: embed,
            itemsContainer: itemsContainer,
            items: items,
            variantId: variantId
          });
        };

        xhr.onerror = function () {
          resolve({
            embed: {
              innerHTML: ''
            },
            itemsContainer: {
              innerHTML: ''
            },
            items: [],
            variantId: variantId
          });
        };

        xhr.responseType = 'document';
        xhr.send();
      });
    }
  }, {
    key: "_injectData",
    value: function _injectData(_ref2) {
      var _this3 = this;

      var embed = _ref2.embed,
          itemsContainer = _ref2.itemsContainer,
          items = _ref2.items,
          variantId = _ref2.variantId;

      if (variantId !== this.latestVariantId || items.length === 0) {
        this.el.innerHTML = '';
        this.el.classList.remove(loadingClass);
        return;
      }

      this.el.innerHTML = embed.innerHTML;
      this.el.classList.remove(loadingClass);
      var calculatedDistances = false;

      var calculateDistances = function calculateDistances() {
        if (calculatedDistances) return Promise.resolve();
        return getLocation(true).then(function (coords) {
          items.forEach(function (item) {
            var distanceEl = item.querySelector('[data-distance]');
            var distanceUnitEl = item.querySelector('[data-distance-unit]');
            var unitSystem = distanceUnitEl.dataset.distanceUnit;
            var itemLatitude = parseFloat(distanceEl.dataset.latitude);
            var itemLongitude = parseFloat(distanceEl.dataset.longitude);

            if (coords && isFinite(itemLatitude) && isFinite(itemLongitude)) {
              var distance = calculateDistance(coords.latitude, coords.longitude, itemLatitude, itemLongitude, unitSystem);
              distanceEl.innerHTML = distance.toFixed(1);
            } else {
              distanceEl.remove();
              distanceUnitEl.remove();
            }
          });
        })["catch"](function (e) {
          console.log(e);
          items.forEach(function (item) {
            var distanceEl = item.querySelector('[data-distance]');
            var distanceUnitEl = item.querySelector('[data-distance-unit]');
            distanceEl.remove();
            distanceUnitEl.remove();
          });
        })["finally"](function () {
          calculatedDistances = true;
        });
      };

      this.el.querySelector('[data-surface-pick-up-embed-modal-btn]').addEventListener('click', function () {
        calculateDistances().then(function () {
          return _this3.callbacks.forEach(function (callback) {
            return callback(itemsContainer.innerHTML);
          });
        });
      });
    }
  }]);

  return SurfacePickUp;
}();

/* harmony default export */ __webpack_exports__["Z"] = (SurfacePickUp);


/***/ }),

/***/ 880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PaymentTerms; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PaymentTerms = /*#__PURE__*/function () {
  function PaymentTerms(el) {
    _classCallCheck(this, PaymentTerms);

    this._el = el;
    if (!this._el) return;
    this._reference = this._el.querySelector('[data-payment-terms-reference] shopify-payment-terms');
    if (!this._reference) return;
    this._target = this._el.querySelector('[data-payment-terms-target]');
    this._input = document.createElement('input');
    this._input.name = 'id';
    this._input.type = 'hidden';

    this._target.appendChild(this._input);

    this._target.appendChild(this._reference);

    this._target.style.display = null;
  }

  _createClass(PaymentTerms, [{
    key: "update",
    value: function update(variantId) {
      if (!this._reference) return;
      this._input.value = variantId;

      this._input.dispatchEvent(new Event('change', {
        bubbles: true
      }));
    }
  }]);

  return PaymentTerms;
}();



/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/************************************************************************/
!function() {
/* harmony import */ var _pixelunion_shopify_surface_pick_up__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(923);
/* harmony import */ var _helpers_PaymentTerms__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(880);


Theme = window.Theme || {};
var Shopify = Shopify || {}; // ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------

Shopify.money_format = "$";

Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }

  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;

    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;

    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;

    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
/*============================================================================
  Global theme settings
==============================================================================*/


Theme.global = {
  arrowShape: 'M8.24174152,52.1419562 C7.78636981,51.7324871 7.50000006,51.1387651 7.50000006,50.478158 L7.50000113,50.4759409 C7.49942646,49.9027311 7.71781139,49.3293425 8.1551559,48.891998 L39.4709454,17.5762085 C40.3444866,16.7026673 41.7607767,16.7026673 42.6343179,17.5762085 C43.5078591,18.4497497 43.5078591,19.8660399 42.6343179,20.7395811 L15.1325831,48.2413159 L90.263158,48.2413159 C91.4985317,48.2413159 92.5000001,49.2427843 92.5000001,50.478158 C92.5000001,51.7135316 91.4985317,52.7150001 90.263158,52.7150001 L15.1415305,52.7150001 L42.6343179,80.2077875 C43.5078591,81.0813287 43.5078591,82.4976188 42.6343179,83.37116 C41.7607767,84.2447011 40.3444866,84.2447011 39.4709454,83.37116 L8.24174152,52.1419562 Z'
};
/*============================================================================
  Header
==============================================================================*/

Theme.header = {
  init: function init() {
    //offscreen check for menu
    $('.mainMenu .dropdown, .mainMenu__submenu, .mainMenu__submenu__submenu').each(function () {
      if ($(this).is(':off-right')) {
        $(this).closest('.dropdown').addClass('dropdown_left');
        $(this).parents('.mainBar__container').removeClass('overflow--hidden');
      }
    });
    $('.overflow--hidden.mainBar__container').removeClass('overflow--hidden'); //Hide announcement bar

    $('.js-close-announcement').on('click', function () {
      $('.announcementBar').hide();
    });
    $('body').on('click', '.search-submit', function () {
      $(this).parent().submit();
    });
    $('.topBar__menu .icon-menu').on('click', function () {
      $('.mobileMenu__overlay').css('margin-left', '0').addClass('is-active').removeClass('is-inactive');
      $('body').addClass('blocked-scroll');
    });
    $('.mobileMenu__close').on('click', function () {
      $('.mobileMenu__overlay').css('margin-left', '-100%').addClass('is-inactive').removeClass('is-active');
      $('body').removeClass('blocked-scroll');
    });

    if (!Theme.utils.is_touch_device() || window.Shopify.media_queries.large.matches) {
      $('.topBar__search').on('mouseenter', function () {
        if (!$(this).hasClass('active_link')) {
          $(this).addClass('active_link');
        }
      });
      $('.topBar__search').on('mouseleave', function () {
        $('.active_link').removeClass('active_link');
      });
      $('.cart_container').on('mouseenter', function () {
        if (!$(this).find('.mini_cart').hasClass('active_link')) {
          $(this).find('.mini_cart').addClass('active_link');
        }
      });
      $('.cart_container').on('mouseleave', function () {
        $('.active_link').removeClass('active_link');
      });
    }

    $('.mini_cart').on('click', function (e) {
      $(this).toggleClass('active_link');

      if (Theme.utils.is_touch_device() || window.Shopify.media_queries.medium.matches) {
        e.preventDefault();
      }
    });
  },
  unload: function unload($target) {
    $('.js-close-announcement').off('click');
    $('body').off('click', '.search-submit');
    $('.topBar__menu .icon-menu').off('click');
    $('.mobileMenu__close').off('click');
    $('.cart_container').off('mouseleave');
    $('.mini_cart').off('click');
  }
};
/*============================================================================
  Image functions
==============================================================================*/

Theme.imageFunctions = {
  enableZoom: function enableZoom() {
    var $image = $(event.target);
    var zoomSrc = $image.data('zoom-src');

    if (zoomSrc) {
      $image.wrap('<span class="zoom-container"></span>').css('display', 'block').parent().zoom({
        url: zoomSrc,
        touch: false,
        magnify: 1
      });
    }
  },
  flickityIosFix: function flickityIosFix() {
    //iOS 13 Flickity fix
    var touchingCarousel = false,
        touchStartCoords;
    document.body.addEventListener('touchstart', function (e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      };
    });
    document.body.addEventListener('touchmove', function (e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };
      if (Math.abs(moveVector.x) > 7) e.preventDefault();
    }, {
      passive: false
    });
  }
};

if (window.Shopify.theme_settings.collection_swatches) {
  Theme.swatches = {
    init: function init() {
      if (window.Shopify.media_queries.large.matches) {
        $('body').on('mouseenter', '.collection_swatches', function () {
          $('.swatch span', $(this)).each(function () {
            if ($(this).data('image').indexOf('no-image') == -1) {
              $('<img/>')[0].src = $(this).data('image');
            }
          });
        });
        $('body').on('mouseenter', '.swatch span', function () {
          if ($(this).data('image').indexOf('no-image') == -1) {
            $(this).parents('.thumbnail').find('img:not(.secondary)').attr('src', $(this).data('image'));
            $(this).parents('.thumbnail').find('img:not(.secondary)').attr('srcset', $(this).data('image'));
          }
        });
      }
    },
    unload: function unload($target) {
      $target.find('.swatch span').off('mouseenter');
      $target.find('.swatch span').off('mouseenter');
    }
  };
}
/*============================================================================
  Article section
==============================================================================*/


Theme.article = {
  init: function init() {
    if (window.location.pathname.indexOf('/comments') != -1) {
      $('html,body').animate({
        scrollTop: $('#new-comment').offset().top - 140
      }, 'slow');
    }
  }
};
/*============================================================================
  Contact form
==============================================================================*/

Theme.contactForm = {
  init: function init() {
    $('[data-datepicker]').each(function (index, value) {
      var dateFormat = $(this).data('date-format');
      var calendarToggle = $(this).find('[data-toggle="datepicker"]');
      $(calendarToggle).datepicker({
        format: dateFormat
      });
    });
    $('.calendar-icon').on('pick.datepicker', function (e) {
      var selectedDate = $(this).datepicker('getDate', true);
      var dateField = $(this).parents('[data-datepicker]').find('[data-date-field]');
      $(dateField).val(selectedDate);
    });
  },
  unload: function unload($target) {
    $('.calendar-icon').off('pick.datepicker');
  }
};
/*============================================================================
  Search autocomplete
==============================================================================*/

var searchAutocomplete = {
  vars: {
    term: '',
    searchPath: window.Shopify.routes.search_url,
    displayTimer: ''
  },
  init: function init() {
    this.unload(); // Focus state to display search results

    $('[data-autocomplete-true]').on('focus', function () {
      $(this).parents('[data-autocomplete-true]').find('.search__results-wrapper').show();
    }); // Clicking outside makes the results disappear

    $(document).on('click focusout', function (e) {
      if (window.Shopify.media_queries.large.matches) {
        var searchForm = $(e.target).parents('.search__form');

        if (searchForm.length === 0) {
          $('[data-autocomplete-true] .search__results-wrapper').hide().removeClass('results-found');
          $('body').removeClass('has-search-overlay');
          $('.search-enabled__overlay').hide();
        }
      }
    });
    $('[data-autocomplete-true] input').on('click touchstart', function (e) {
      if (window.Shopify.media_queries.medium.matches) {
        var formType = $(this).closest('form').find('[name="type"]').val();
        var position = $(document).scrollTop();
        searchAutocomplete.showMobileSearch(formType, position);
      }
    });
    $('.close-search').on('click touchstart', function () {
      $('body').removeClass('is-active');
      $('.dropdown_link').removeClass('active_link');
      $('.dropdown_container').hide();
      $('.mobile_nav').find('div').removeClass('open');
      $('[data-autocomplete-true] .search__results-wrapper').hide().removeClass('results-found');
      $('.search-enabled__overlay').hide();
    }); // Submit wildcard searches

    $("[data-autocomplete-true] form").on("submit", function (e) {
      if (window.Shopify.media_queries.large.matches) {
        e.preventDefault();
        var formValue = $(this).find('input[name="q"]').val();
        var cleanFormValue = encodeURI(formValue);

        if ($(this).find('[name="type"]').length > 0) {
          var searchType = $(this).find('[name="type"]').val();
        } else {
          var searchType = window.Shopify.theme_settings.search_option;
        }

        if (cleanFormValue == null) {
          window.location.href = window.Shopify.routes.search_url + '?type=' + searchType;
        } else {
          window.location.href = searchAutocomplete.vars.searchPath + '?type=' + searchType + '&q=' + cleanFormValue + '*';
        }
      }
    });
    $('[data-autocomplete-true] form').each(function () {
      var $this = $(this);
      var input = $this.find('input[name="q"]'); // Adding a list for showing search results.

      $('<div class="search__results-wrapper"><ul class="search__results"></ul></div>').appendTo($this);
      input.attr('autocomplete', 'off').on('input', function () {
        clearTimeout(searchAutocomplete.vars.displayTimer);

        if ($(this).val().length > 3) {
          searchAutocomplete.vars.term = $(this).val();
          searchAutocomplete.getResults(searchAutocomplete.vars.term, $this);
        } else {
          $('[data-autocomplete-true] .search__results-wrapper').hide().removeClass('results-found');
          $('.search-enabled__overlay').hide();
        }
      });
    });
  },
  getResults: function getResults(term, $this) {
    if ($this.find('[name="type"]').length > 0) {
      var searchType = $this.find('[name="type"]').val();
    } else {
      var searchType = window.Shopify.theme_settings.search_option;
    }

    jQuery.getJSON("/search/suggest.json", {
      "q": term,
      "resources": {
        "type": searchType,
        "limit": window.Shopify.theme_settings.search_items_to_display,
        "options": {
          "unavailable_products": "last",
          "fields": "title,body,variants.title,vendor,product_type,tag"
        }
      }
    }).done(function (response) {
      var suggestions = [response.resources.results.products, response.resources.results.pages, response.resources.results.articles];
      var filteredResults = []; // Store results in array

      $.each(suggestions, function (index, suggestion) {
        if (suggestion !== undefined && suggestion.length > 0) {
          // Ensure suggestion exists
          filteredResults.push(suggestion);
        }
      }); // Display results

      searchAutocomplete.vars.displayTimer = setTimeout(function () {
        searchAutocomplete.displayResults(filteredResults[0], $this);
      }, 500);
    });
  },
  displayResults: function displayResults(results, $this) {
    var $resultsWrapper = $this.find('.search__results-wrapper');
    var $resultsList = $this.find('.search__results');
    $resultsWrapper.show();
    $resultsList.empty();

    if ($this.find('[name="type"]').length > 0) {
      var searchType = $this.find('[name="type"]').val();
    } else {
      var searchType = window.Shopify.theme_settings.search_option;
    }

    if ($this.parents('.top_bar').length > 0) {
      $('.search-enabled__overlay').show();
    }

    if (results && results.length > 0) {
      $.each(results, function (index, result) {
        var link = $('<a tabindex="0"></a>').attr('href', result.url);

        if (window.Shopify.routes.root_url !== '/') {
          link = $('<a tabindex="0"></a>').attr('href', window.Shopify.routes.root_url + result.url);
        } // if result is a product


        if (result['price']) {
          function formatPrice(price) {
            if (Currency.display_format === 'money_with_currency_format') {
              return '<span class="money">' + Currency.symbol + price + ' ' + Currency.iso_code + '</span>';
            } else {
              return '<span class="money">' + Currency.symbol + price + '</span>';
            }
          }

          if (result.available === true) {
            if (result.compare_at_price_max > result.price_max || result.compare_at_price_min > result.price_min) {
              var itemPrice = formatPrice(result.price) + ' <span class="was_price">' + formatPrice(result.compare_at_price_max) + '</span>';
            } else {
              if (result.price > 0) {
                if (result.price_min != result.price_max) {
                  var itemPrice = window.Shopify.translation.product_from + ' ' + formatPrice(result.price);
                } else {
                  var itemPrice = formatPrice(result.price);
                }
              } else {
                var itemPrice = window.Shopify.theme_settings.free_text;
              }
            }
          } else {
            var itemPrice = window.Shopify.translation.product_sold_out;
          } // If result has an image


          if (result['image']) {
            link.append('<div class="thumbnail"><img class="lazyload lazyload--fade-in" src="' + Theme.utils.addImageDimension(result['image'], '_300x') + '" /></div>');
          }

          link.append('<div class="title">' + result.title + '<br><span class="item-pricing price">' + itemPrice + '</span></div>'); // If result is an article
        } else if (result['summary_html']) {
          if (result.image != 'NULL') {
            link.append('<div class="thumbnail"><img class="lazyload lazyload--fade-in" src="' + Theme.utils.addImageDimension(result['image'], '_300x') + '" /></div>');
          }

          link.append('<div class="title">' + result.title + '<br><span class="item-description">' + result.summary_html.replace(/(<([^>]+)>)/ig, "").slice(0, 25) + ' </span></div>'); // If result is a page
        } else if (result['published_at']) {
          link.append('<div class="title">' + result.title + '<br><span class="item-description">' + result.body.replace(/(<([^>]+)>)/ig, "").slice(0, 25) + ' </span></div>');
        } // Wrap link and append to list


        link.wrap('<li class="item-result"></li>');
        $resultsList.append(link.parent());
      });

      if (Currency.native_multi_currency && Currency.shipping_calculator) {
        currencyConverter.init();
      }

      $resultsList.parents('.search__results-wrapper').addClass('results-found');
      $resultsList.prepend('<li class="all-results"><span class="see-all"><a href="' + this.vars.searchPath + '?type=' + searchType + '&q=' + this.vars.term + '*">' + window.Shopify.translation.all_results + '<span class="icon-right-caret"></span></a></span></li>');
    } else {
      // if no results
      var noResults = '<li class="item-result"><span class="no-results title">' + window.Shopify.translation.no_results + '</span></li>';
      $resultsList.append(noResults);
      $resultsList.parents('.search__results-wrapper').removeClass('results-found');
    }

    $resultsList.show();
  },
  showMobileSearch: function showMobileSearch(formType, position) {
    $('body').css('max-height', window.innerHeight);
    $('.mobile-search').fadeIn(200);

    if (/iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
      $('.mobile-search input#q').focus();
    } else {
      //Set delay to ensure focus triggers on android
      setTimeout(function () {
        $('.mobile-search input#q').focus();
      }, 205);
    }

    document.body.style.position = 'fixed';
    document.body.style.top = '-' + position + 'px';
    $('.mobile-search').css('top', position);
    var searchHeight = window.innerHeight - 60; //Full screen height - form height

    $('.mobile-search .search__results-wrapper').css('max-height', searchHeight);

    if (formType) {
      $('.mobile-search [name="type"]').val(formType);
    } else {
      $('.mobile-search [name="type"]').val(window.Shopify.theme_settings.search_option);
    }

    $('.search-form .close-search').on('click touchstart', function (e) {
      e.preventDefault();
      e.stopPropagation();
      searchAutocomplete.hideMobileSearch(position);
      $('[data-autocomplete-true] .search__results-wrapper').hide().removeClass('results-found');
    });
    $('.search-form .submit-search').on('click touchstart', function (e) {
      $(this).parents('form').submit();
    });
  },
  hideMobileSearch: function hideMobileSearch(position) {
    $('body').css('max-height', 'none');
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, position);
    $('.mobile-search').fadeOut(200);
    $('.mobile-search [name="q"]').val('');
    $('body').off('focus', '.search-form .close-search');
    $('body').off('focus', '.search-form .submit-search');
  },
  unload: function unload() {
    $('body').off('focus', '[data-autocomplete-true] input');
    $('input[name="q"]').off();
    $('[data-dropdown-rel="search"], [data-autocomplete-true] input').off();
    $('.search__results-wrapper').remove();
  }
};
/*============================================================================
  Newsletter Popup
==============================================================================*/

Theme.newsletter_popup = {
  newsletter_popup_days: $('[data-popup]').data('newsletter-popup-days'),
  newsletter_popup_seconds: $('[data-popup]').data('newsletter-popup-seconds'),
  newsletter_popup_mobile: $('[data-popup]').data('newsletter-popup-mobile'),
  init: function init() {
    var popup = Cookies.get('popup');
    var cookie_enabled = this.newsletter_popup_days != 0 ? true : false;

    if (cookie_enabled && popup == 'open') {
      return false;
    } else {
      Theme.newsletter_popup.open();
    }

    if (cookie_enabled) {
      Cookies.set('popup', 'open', {
        expires: this.newsletter_popup_days
      });
    }
  },
  open: function open(trigger) {
    if (trigger == 'editor') {
      $.fancybox.close();
      $.fancybox.open($('.js-newsletter-popup'), {
        baseClass: 'newsletterPopupModal',
        hash: false,
        infobar: false,
        toolbar: false,
        loop: true,
        smallBtn: true,
        mobile: {
          preventCaptionOverlap: false,
          toolbar: true,
          buttons: ["close"]
        }
      });
    } else {
      var newsletter_popup_seconds = parseInt(this.newsletter_popup_seconds);

      if (this.newsletter_popup_mobile || window.Shopify.media_queries.large.matches) {
        setTimeout(function () {
          $.fancybox.open($('.js-newsletter-popup'), {
            baseClass: 'newsletterPopupModal',
            hash: false,
            infobar: false,
            toolbar: false,
            loop: true,
            smallBtn: true,
            mobile: {
              preventCaptionOverlap: false,
              toolbar: true,
              buttons: ["close"]
            }
          });
        }, newsletter_popup_seconds * 1000);
      }
    }
  },
  close: function close() {
    $.fancybox.close();
  }
};
/*============================================================================
  Quick shop
==============================================================================*/

Theme.quickShop = {
  init: function init() {
    //Dropdown toggler
    $('.productForm__select select').each(function () {
      var selectedOption = $(this).find(':selected').data('image');
      var $quickShopElement = $(this).parents('.thumbnail');
      $quickShopElement.find('.image-element__wrap img').attr('src', selectedOption);
      $quickShopElement.find('.image-element__wrap img').attr('srcset', selectedOption);
    }); //Swatch toggler

    $('.swatch_options input').each(function () {
      if ($(this).is(':checked')) {
        Theme.quickShop.toggleSwatchImages($(this));
      }
    });
    $('.swatch_options label').on('click', function () {
      Theme.quickShop.toggleSwatchImages($(this));
    });
    $('.js-quickShop__button--more-options').on('click', function (e) {
      var $thumbnail = $(this).parents('.thumbnail');
      var $parentForm = $(this).parents('form');
      e.preventDefault(); // Show quick shop

      $thumbnail.removeClass('quickShop--closed').addClass('quickShop--opened'); // Display variants

      if (window.Shopify.theme_settings.product_form_style == "swatches") {
        $parentForm.find('.swatch_options').slideDown().css('display', 'flex');
      } else {
        $parentForm.find('.productForm__select').slideDown().css('display', 'flex');
      }
    });
    $('.thumbnail.quickShop--variants').on('mouseleave', function (e) {
      // Check if we actually leave the quickshop rather than click into variants
      if (e.relatedTarget || e.toElement) {
        $(this).removeClass('quickShop--opened').addClass('quickShop--closed');

        if (window.Shopify.theme_settings.product_form_style == "swatches") {
          $(this).find('.swatch_options').slideUp();
        } else {
          $(this).find('.productForm__select').slideUp();
        }
      }
    });
  },
  toggleSwatchImages: function toggleSwatchImages(swatchInput) {
    var $swatchElement = $(swatchInput).closest('.swatch-element');
    var swatchImageID = $swatchElement.find('[data-image]').data('image');
    var $quickShopElement = $swatchElement.parents('.thumbnail').find('.image-element__wrap img');
    $quickShopElement.attr('src', swatchImageID);
    $quickShopElement.attr('srcset', swatchImageID);
  },
  unload: function unload($target) {
    $('.js-quickShop__button').off('click');
    $('.swatch_options label').off('click');
  }
};
/*============================================================================
  Password page
==============================================================================*/

Theme.password = {
  init: function init() {
    $('#open-me').on('click', function () {
      $('.overlay').addClass('overlay-open');
      $('#password-container').addClass('modal--open');
    });
    $('.close-me').on('click', function () {
      $('.overlay').removeClass('overlay-open');
      $('#password-container').removeClass('modal--open');
    });
  },
  unload: function unload($target) {
    $('#open-me').off('click');
    $('#close-me').off('click');
  }
};
/*============================================================================
  Pricing table section
==============================================================================*/

Theme.pricingTable = {
  init: function init() {
    $('.pricingTable__header').on('click', function () {
      var columnNumber = $(this).data('column');
      $(this).siblings().removeClass('pricingTable__header--active');
      $(this).addClass('pricingTable__header--active');
      $(this).parents('.pricingTable').find('[data-pricing-column]').removeClass('pricingTable--active');
      $(this).parents('.pricingTable').find('[data-pricing-column=' + columnNumber + ']').addClass('pricingTable--active');
      var backgroundColor = $(this).prop('style').backgroundColor;
      $(this).parent('.pricingTable__headers').css('borderColor', backgroundColor);
    });
  },
  addHeaderLink: function addHeaderLink() {
    var goToUrl = $('[data-product-link]').data('product-link');
    $('[data-product-link]').attr('href', goToUrl);
  },
  removeHeaderLink: function removeHeaderLink() {
    $('[data-product-link]').removeAttr('href');
  },
  unload: function unload($target) {
    $('.pricingTable__header').off('click');
  }
};
/*============================================================================
  Slideshow section
==============================================================================*/

Theme.slideshow = {
  init: function init($target) {
    $('.js-slideshow').each(function (index, value) {
      var $homepageSlider = $(this);
      var draggable = false;
      var prevNextButtons = false;
      var pageDots = false;

      if ($homepageSlider.data('column-amount') > 1) {
        prevNextButtons = true;
        draggable = true;
        pageDots = true;
      }

      var settings = {
        slideshowSpeed: $homepageSlider.data('slideshow-speed'),
        slideshowTextAnimation: $homepageSlider.data('slideshow-text-animation')
      }; //initiate the slideshow

      if (!$homepageSlider.hasClass('flickity-enabled')) {
        $homepageSlider.flickity({
          draggable: draggable,
          dragThreshold: 15,
          wrapAround: true,
          imagesLoaded: true,
          prevNextButtons: prevNextButtons,
          pageDots: pageDots,
          cellAlign: 'left',
          lazyLoad: false,
          autoPlay: settings.slideshowSpeed,
          arrowShape: Theme.global.arrowShape
        });
      }
    });
  },
  unload: function unload($target) {
    var $slider = $target.find('.js-slideshow');
    $slider.flickity('destroy');
  }
};
/*============================================================================
  Testimonials section
==============================================================================*/

Theme.testimonials = {
  init: function init($target) {
    $('.js-homepage-testimonial').each(function (index, value) {
      var $testimonialsSlider = $(this);

      if ($testimonialsSlider.data('column-amount') > 3) {
        if (window.Shopify.media_queries.large.matches) {
          var initialIndex = 1;
        } else {
          var initialIndex = 0;
        } //initiate the slider


        if (!$testimonialsSlider.hasClass('flickity-enabled')) {
          $testimonialsSlider.flickity({
            draggable: true,
            wrapAround: true,
            imagesLoaded: true,
            initialIndex: initialIndex,
            prevNextButtons: true,
            dragThreshold: 15,
            pageDots: true,
            cellAlign: 'center',
            lazyLoad: false,
            arrowShape: Theme.global.arrowShape
          });
        }
      }
    });
  },
  unload: function unload($target) {
    var $slider = $target.find('.js-homepage-testimonial.flickity-enabled');

    if ($slider) {
      $slider.flickity('destroy');
    }
  }
};
/*============================================================================
  Cart
==============================================================================*/

Theme.cart = {
  init: function init() {
    Theme.utils.initializeQuantityBox();

    if (Currency.native_multi_currency && Currency.shipping_calculator) {
      currencyConverter.init();
    } //Terms of service on cart page


    if ($('#cart_form .tos_agree, #mini_cart_form .tos_agree').length) {
      Theme.cart.termsOfServiceCheck();
    } //Get product quantity on cart page


    $('body').on('change', '#cart_form input.quantity', function () {
      var $this = $(this);

      if ($this.val() == 0) {
        $this.parents('.cart__card').slideUp(function () {
          Theme.cart.ajaxUpdateCart($this.data('line-id'), $this.val());
        });
      } else {
        Theme.cart.ajaxUpdateCart($this.data('line-id'), $this.val());
      }
    }); //Remove product from cart page

    $('body').on('click', '#cart_form .cart__removeBtn, #mini_cart_form .cart__removeBtn', function (e) {
      e.preventDefault();
      var $this = $(this);
      var $cartCard = $this.parents('.cart__card');
      $cartCard.slideUp(function () {
        Theme.cart.ajaxUpdateCart($cartCard.data('line-id'), 0);
      });
    }); //Get product quantity on product page

    $('body').on('change', '.cart_content input.quantity', function () {
      Theme.cart.ajaxUpdateCart($(this).data('line-id'), $(this).val());
    });

    if (window.Shopify.theme_settings.cart_action == 'ajax') {
      Theme.cart.registerAjaxCart();
    }
  },
  termsOfServiceCheck: function termsOfServiceCheck() {
    $('body').on('click', "#cart_form input[type='submit'], #mini_cart_form input[type='submit']", function () {
      if ($(this).parents('form').find('.tos_agree').length >= 1) {
        if ($(this).parents('form').find('.tos_agree').is(':checked')) {
          $(this).submit();
        } else {
          var warning = '<p class="warning animated bounceIn">' + window.Shopify.translation.agree_to_terms_warning + '</p>';

          if ($('p.warning').length == 0) {
            $(this).parent('.miniCart__buttons').find('.warning-box').append(warning);
          }

          return false;
        }
      }
    });
  },
  registerAjaxCart: function registerAjaxCart() {
    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      var $addToCartForm = $(this).closest('form');
      var $addToCartBtn = $addToCartForm.find('.add_to_cart');
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function beforeSend() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass("slideInLeft").addClass('animated slideOutRight');
        },
        success: function success(itemData) {
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');
          window.setTimeout(function () {
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('slideOutRight').addClass('slideInLeft');
          }, 1000);
          window.setTimeout(function () {
            $addToCartBtn.find('span').removeClass('slideInLeft');
          }, 1500);
          $.ajax({
            url: '/cart.js',
            dataType: "json",
            cache: false,
            success: function success(cart) {
              Theme.cart.refreshMiniCart(cart);
            }
          });
        },
        error: function error(XMLHttpRequest) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
          $('.warning').remove();
          var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
          $addToCartForm.after(warning);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text(window.Shopify.translation.product_add_to_cart).removeClass('zoomOut').addClass('zoomIn');
          window.setTimeout(function () {
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('slideOutRight').addClass('slideInLeft');
          }, 1000);
        }
      });
      return false;
    });
  },
  ajaxUpdateCart: function ajaxUpdateCart(lineID, quantity) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: {
        quantity: quantity,
        line: lineID
      }
    }).done(function (data) {
      Theme.cart.refreshMiniCart(data);
      Theme.cart.refreshCartPage(data); //Check inventory levels on minicart and cart page

      var lineIDIndex = lineID - 1;
      var $currentDiscount = $('#cart_form').data('currentDiscount');
      var newQuantity = 0; //check to see if there are correct amount of products in array

      if (typeof data.items[lineIDIndex] === "undefined") {
        var updated_quantity = 0;
      } else {
        var updated_quantity = data.items[lineIDIndex].quantity;
      }

      $('.warning--quantity').remove();

      if (quantity > 0 && quantity != updated_quantity) {
        if (updated_quantity == 1) {
          var items_left_text = window.Shopify.translation.items_left_count_one;
        } else {
          var items_left_text = window.Shopify.translation.items_left_count_other;
        }

        var warning = '<p class="warning warning--quantity animated bounceIn">' + updated_quantity + ' ' + items_left_text + '</p>';
      }

      $('.cart__quantityWrap').find("input[data-line-id='" + lineID + "']").parent().after(warning);
      $('.cart__quantityWrap').find("input[data-line-id='" + lineID + "']").val(updated_quantity);

      if ($('#cart_form input.quantity').length) {
        location.reload();
      }
    }).fail(function (error) {
      console.error('I am an error', error);
    });
  },
  refreshCartPage: function refreshCartPage(cart) {
    $('.cart__itemCount').text(cart.item_count);
    $('.cart__card:visible').each(function (index) {
      var newLineID = index + 1;
      $(this).find('.quantity').attr('data-line-id', newLineID);
    });

    if (cart.item_count == 0) {
      $('#cart_form, #mini_cart_form').fadeOut(function () {
        $('.cart__emptyWrapper').removeClass('hidden');
        $('form#cart_form, form#mini_cart_form').addClass('hidden');
      });
    } else {
      $('.cart__emptyWrapper').addClass('hidden');
      $('#cart_form, form#mini_cart_form').removeClass('hidden');
    }
  },
  refreshMiniCart: function refreshMiniCart(cart) {
    var $cartBtn = $(".topBar__cartCount");
    var value = $cartBtn.text() || '0';
    var cart_items_html = "";
    var cart_action_html = "";
    var cart_savings_html = "";
    var $cart = $(".js-cart_content__form");
    var discounted_price_total = 0;
    $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));

    if (cart.item_count == 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $('.js-cart_content__form, .cart_count').addClass('hidden');
    } else {
      $('.js-empty-cart__message').addClass('hidden');
      $('.js-cart_content__form, .cart_count').removeClass('hidden');
      $.each(cart.items, function (index, item) {
        var itemDiscounts = item.discounts;
        var discountMessage = "";

        for (i = 0; i < itemDiscounts.length; i++) {
          var amount = Shopify.formatMoney(itemDiscounts[i].amount, $('body').data('money-format'));
          var title = itemDiscounts[i].title;
          discountMessage = '<p class="notification-discount meta"><strong>' + window.Shopify.translation.cart_discount + ':</strong> ' + title + ' (-<span class="money">' + amount + '</span>)</p>';
        }

        var line_id = index + 1;
        cart_items_html += '<li class="miniCart__item cart_item" data-line-id="' + line_id + '">';

        if (item.image) {
          cart_items_html += '<div class="miniCart__image cart_image"><a href="' + item.url + '">' + '<img src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" alt="' + Theme.utils.htmlEncode(item.title) + '" />' + '</a></div>';
        }

        cart_items_html += '<div class="miniCart__itemDetails">';
        cart_items_html += '<div class="miniCart__itemTitle"><a href="' + item.url + '" class="item__link">' + item.title + '</a>';

        if (item.properties) {
          $.each(item.properties, function (title, value) {
            if (value) {
              cart_items_html += '<div class="line-item">' + title + ': ' + value + '</div>';
            }
          });
        }

        if (item.price > item.final_price) {
          cart_items_html += discountMessage;
        }

        cart_items_html += '</div>';

        if (item.price > item.final_price) {
          cart_items_html += '<div class="miniCart__price"><strong><span class="price money">' + Shopify.formatMoney(item.final_price, $('body').data('money-format')) + '</span></strong><span class="was_price money">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span></div>';
        } else {
          cart_items_html += '<div class="miniCart__price"><strong><span class="price money">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span></strong></div>';
        }

        cart_items_html += '</div>';
        cart_items_html += '<div class="miniCart__delete textAlign--right"><a class="miniCart__removeBtn cart__removeBtn" href="/cart/change?line=' + line_id + '&amp;quantity=0" title="' + window.Shopify.translation.cart_remove + '"><span class="icon-cross"></span></a></div>';
        cart_items_html += '</li>';
      });
      var cartDiscounts = cart.cart_level_discount_applications;

      for (i = 0; i < cartDiscounts.length; i++) {
        var amount = Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
        var title = cartDiscounts[i].title;
      }

      if (cart.cart_level_discount_applications.length > 0) {
        cart_action_html += '<p><span class="subtotal__text">' + window.Shopify.translation.cart_discount + ':</span> ' + title + ' <span class="money">' + amount + '</span></p>';
      }

      cart_action_html += '<p><span class="subtotal__text">' + window.Shopify.translation.subtotal + ':</span> <span class="money">' + Shopify.formatMoney(cart.total_price, $('body').data('money-format')) + '</span></p>';
      cart_savings_html = "";
    }

    $('.js-cart_items').html(cart_items_html);
    $('.js-cart_subtotal').html(cart_action_html);
    $('.js-cart_savings').html(cart_savings_html);
  }
};
/*============================================================================
  Select callback
==============================================================================*/

Theme.selectCallback = function (variant, selector) {
  var $product = $('.product-' + selector.product.id);
  var $notify_form = $('.notify-form-' + selector.product.id);
  var $productForm = $('.product_form', $product);
  var variantInventory = $productForm.data('variant-inventory');
  var $notifyFormInputs = $('.notify_form__inputs', $product);
  var notifyMeDescription = "<p>Email me when this is made again please: </p>";
  var notifyEmail = window.Shopify.translation.product_notify_form_email;
  var notifyEmailValue = "";
  var notifySend = "Send";
  var notifyMessage = $notifyFormInputs.data('notify-message');

  if (variant && variant.title) {
    notifyMessage = notifyMessage + ' - ' + variant.title.replace(/"/g, '\&quot;');
  }

  if ($notifyFormInputs.hasClass('customer--true')) {
    var notifyCustomerEmail = "";
    var notifyEmailInput = notifyMeDescription + '<input type="hidden" class="notify_email" name="contact[email]" id="contact[email]" value="' + notifyCustomerEmail + ' "/>';
  } else {
    var notifyEmailInput = notifyMeDescription + '<input required type="email" class="notify_email" name="contact[email]" id="contact[email]" placeholder="' + notifyEmail + '" value="' + notifyEmailValue + '" />';
  }

  var notifyFormHTML = notifyEmailInput + '<input type="hidden" name="challenge" value="false" /><input type="hidden" name="contact[body]" class="notify_form_message" data-notify-message="' + notifyMessage + '" value="' + notifyMessage + '" /><input class="action_button" type="submit" value="' + notifySend + '" style="margin-bottom:0px" />'; //Image Variant feature

  if (variant && variant.featured_image && $product.is(":visible")) {
    var $sliders = $('.product_gallery', $product);
    $sliders.each(function () {
      var $slider = $(this);
      var $sliderInstance = Flickity.data(this);

      if ($slider.is(":visible") && $sliderInstance != undefined) {
        var index = $('[data-image-id="' + variant.featured_media.id + '"]').data('index');
        $sliderInstance.select(index, false, true);
      }
    });
  } // Unit price


  var unitPriceMeasurementReferenceValue = '';
  var unitPriceOutput = '';

  if (variant) {
    if (variantInventory) {
      variantInventory.forEach(function (v) {
        if (v.id === variant.id) {
          variant.inventory_quantity = v.inventory_quantity;
          variant.inventory_management = v.inventory_management;
          variant.inventory_policy = v.inventory_policy;
        }
      });
    }

    $('.product__sku span', $product).text(variant.sku);

    if (window.Shopify.theme_settings.product_form_style == "swatches") {
      for (var i = 0, length = variant.options.length; i < length; i++) {
        var radioButton = $productForm.find('.swatch[data-option-index="' + escape(i) + '"] :radio[value="' + variant.options[i].replace(/\"/g, '\\"') + '"]');

        if (radioButton.length) {
          radioButton.get(0).checked = true;
        }
      }
    }

    if (variant.unit_price_measurement) {
      if (variant.unit_price_measurement.reference_value != 1) {
        unitPriceMeasurementReferenceValue = variant.unit_price_measurement.reference_value;
      }

      unitPriceOutput += "<div class=\"item_unit-price\">".concat(variant.unit_price_measurement.quantity_value).concat(variant.unit_price_measurement.quantity_unit, " | ").concat(Shopify.formatMoney(variant.unit_price, $('body').data('money-format')), " / ").concat(unitPriceMeasurementReferenceValue).concat(variant.unit_price_measurement.reference_unit, "</div>");
    }
  }

  var $unitPrice = $('.product-details__unit-price', $product);
  $unitPrice.removeClass('product-details__unit-price--hidden');

  if (variant && variant.available == true) {
    $('.shopify-payment-button__button, .shopify-payment-button__more-options', $product).show();

    if (variant.price < variant.compare_at_price) {
      $('.was_price', $product).html('<span class="money">' + Shopify.formatMoney(variant.compare_at_price, $('body').data('money-format')) + '</span>');
      $('.savings', $product).html(window.Shopify.translation.product_savings + ' ' + parseInt((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '% (' + '<span class="money">' + Shopify.formatMoney(variant.compare_at_price - variant.price, $('body').data('money-format')) + '</span>)');
      $('.sale_banner', $product).show();
    } else {
      $('.was_price', $product).html('');
      $('.savings', $product).html('');
      $('.sale_banner', $product).hide();
    }

    if (variant.inventory_management && variant.inventory_quantity > 0) {
      if (window.Shopify.theme_settings.display_inventory_left) {
        if (variant.inventory_quantity == 1) {
          var items_left_text = window.Shopify.translation.items_left_count_one;
        } else {
          var items_left_text = window.Shopify.translation.items_left_count_other;
        }

        var inventoryThreshold = window.Shopify.theme_settings.enable_quickshop;

        if (variant.inventory_quantity <= inventoryThreshold) {
          $('.items_left', $product).html(variant.inventory_quantity + " " + items_left_text);
        } else {
          $('.items_left', $product).html("");
        }
      }

      if (window.Shopify.theme_settings.limit_quantity) {
        if (variant.inventory_policy == "deny") {
          $('.quantity', $product).attr('max', variant.inventory_quantity);
        }
      }
    } else {
      $('.items_left', $product).text('');
      $('.quantity', $product).removeAttr('max');
    }

    $('.sold_out', $product).text('');

    if (variant.price > 0) {
      $('.current_price', $product).html('<span class="money">' + Shopify.formatMoney(variant.price, $('body').data('money-format')) + '</span>');

      if (unitPriceOutput !== undefined) {
        $unitPrice.html(unitPriceOutput);
      } else {
        $unitPrice.addClass('product-details__unit-price--hidden');
      }
    } else {
      $('.current_price', $product).html(window.Shopify.theme_settings.free_price_text);
      $unitPrice.addClass('product-details__unit-price--hidden');
    }

    $('.add_to_cart:not(.quickShop__button--more-options)', $product).find('span').text($('.add_to_cart:not(.quickShop__button--more-options)', $product).data('label'));
    $notify_form.hide(); // removes fade out text and shows prices

    $('.was_price', $product).removeClass('sold_out_price').show();
    $('.savings', $product).removeClass('sold_out_price').show();
    $('.current_price', $product).removeClass('sold_out_price').show();
    $('.shopify-payment-button__button').removeClass('disabled');
    $('.productForm__quantity', $product).show(); // removes disabled from action buttons

    $('.atc-btn-container', $product).removeClass('disabled');
  } else {
    var message = variant ? window.Shopify.translation.product_sold_out : window.Shopify.translation.product_unavailable; // hides quantity input

    $('.productForm__quantity', $product).hide(); // fade out and show prices if variant is sold out

    $('.was_price', $product).addClass('sold_out_price').show();
    $('.savings', $product).addClass('sold_out_price').show();
    $('.current_price', $product).addClass('sold_out_price').show();
    $('.items_left', $product).text(''); // disables atc and buy now when variant is sold out

    $('.shopify-payment-button__button').addClass('disabled');
    $('.add_to_cart:not(.quickShop__button--more-options)', $product).find('span').text(message); // adds disabled attribute from action buttons

    $('.atc-btn-container', $product).addClass('disabled');

    if (variant) {
      // For when variant is specifically sold out
      $('.sold_out', $product).text(' — ' + message);

      if (variant.price > 0) {
        $('.current_price', $product).html('<span class="money">' + Shopify.formatMoney(variant.price, $('body').data('money-format')) + '</span>');

        if (unitPriceOutput !== undefined) {
          $unitPrice.html(unitPriceOutput);
        } else {
          $unitPrice.addClass('product-details__unit-price--hidden');
        }
      } else {
        $('.current_price', $product).html(window.Shopify.theme_settings.free_price_text);
        $unitPrice.addClass('product-details__unit-price--hidden');
      } // for when variant is sold out but on sale


      if (variant.price < variant.compare_at_price) {
        $('.was_price', $product).html('<span class="money">' + Shopify.formatMoney(variant.compare_at_price, $('body').data('money-format')) + '</span>');
        $('.savings', $product).html(window.Shopify.translation.product_savings + ' ' + parseInt((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '% (' + '<span class="money">' + Shopify.formatMoney(variant.compare_at_price - variant.price, $('body').data('money-format')) + '</span>)');
        $('.sale_banner', $product).show();
      } else {
        $('.was_price', $product).html('');
        $('.savings', $product).html('');
        $('.sale_banner', $product).hide();
      }

      $notify_form.fadeIn();
      $notifyFormInputs.empty();
      $notifyFormInputs.append(notifyFormHTML);
      $('.sold_out_price').show();
    } else {
      // stuff for when variant is specifically unavailable
      $('.sale_banner', $product).hide();
      $unitPrice.addClass('product-details__unit-price--hidden');
      $('.sold_out', $product).text(message); // hides price and notify form if variant is unavailable

      $notify_form.hide();
      $('.sold_out_price').hide();
    }
  }
};
/*============================================================================
  Map
==============================================================================*/


Theme.map = {
  init: function init() {
    if ($('.maps').hasClass('js-api-map')) {
      var mapsToLoad = []; //Create map settings array

      $('.map').each(function (i, obj) {
        mapsToLoad.push(this);
        mapsToLoad[i].sectionid = $(this).data('id');
        mapsToLoad[i].address = $(this).data('address');
        mapsToLoad[i].directions = $(this).data('directions-address');
        mapsToLoad[i].zoom = $(this).data('zoom');
        mapsToLoad[i].mapstyle = $(this).data('style');
        mapsToLoad[i].showpin = $(this).data('pin');
        mapsToLoad[i].apikey = $(this).data('api-key');
      });
      $.each(mapsToLoad, function (i, instance) {
        //Enable caching to avoid duplicate google maps files
        $.ajaxSetup({
          cache: true
        }); //Load maps script and find location coordinates

        $.getScript('https://maps.googleapis.com/maps/api/js?key=' + mapsToLoad[i].apikey).then(function () {
          Theme.map.findLocation(mapsToLoad[i]);
          $.ajaxSetup({
            cache: false
          });
        });
      });
    }
  },
  findLocation: function findLocation(mapArray) {
    var geoLat;
    var geoLng;
    var geocoder = new google.maps.Geocoder(); //Find and set coordinates

    geocoder.geocode({
      address: mapArray.address
    }, function (results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        geoLat = results[0].geometry.location.lat();
        geoLng = results[0].geometry.location.lng(); //Create map

        Theme.map.initMap(geoLat, geoLng, mapArray);
      } else {
        console.log('Error:' + status);
      }
    });
  },
  initMap: function initMap(lat, lng, mapArray) {
    var location = {
      lat: lat,
      lng: lng
    };
    var styleJson = []; //Set style JSON

    if (mapArray.mapstyle == 'aubergine') {
      styleJson = [{
        elementType: 'geometry',
        stylers: [{
          color: '#1d2c4d'
        }]
      }, {
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#8ec3b9'
        }]
      }, {
        elementType: 'labels.text.stroke',
        stylers: [{
          color: '#1a3646'
        }]
      }, {
        featureType: 'administrative.country',
        elementType: 'geometry.stroke',
        stylers: [{
          color: '#4b6878'
        }]
      }, {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#64779e'
        }]
      }, {
        featureType: 'administrative.province',
        elementType: 'geometry.stroke',
        stylers: [{
          color: '#4b6878'
        }]
      }, {
        featureType: 'landscape.man_made',
        elementType: 'geometry.stroke',
        stylers: [{
          color: '#334e87'
        }]
      }, {
        featureType: 'landscape.natural',
        elementType: 'geometry',
        stylers: [{
          color: '#023e58'
        }]
      }, {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{
          color: '#283d6a'
        }]
      }, {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#6f9ba5'
        }]
      }, {
        featureType: 'poi',
        elementType: 'labels.text.stroke',
        stylers: [{
          color: '#1d2c4d'
        }]
      }, {
        featureType: 'poi.park',
        elementType: 'geometry.fill',
        stylers: [{
          color: '#023e58'
        }]
      }, {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#3C7680'
        }]
      }, {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{
          color: '#304a7d'
        }]
      }, {
        featureType: 'road',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#98a5be'
        }]
      }, {
        featureType: 'road',
        elementType: 'labels.text.stroke',
        stylers: [{
          color: '#1d2c4d'
        }]
      }, {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{
          color: '#2c6675'
        }]
      }, {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [{
          color: '#255763'
        }]
      }, {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#b0d5ce'
        }]
      }, {
        featureType: 'road.highway',
        elementType: 'labels.text.stroke',
        stylers: [{
          color: '#023e58'
        }]
      }, {
        featureType: 'transit',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#98a5be'
        }]
      }, {
        featureType: 'transit',
        elementType: 'labels.text.stroke',
        stylers: [{
          color: '#1d2c4d'
        }]
      }, {
        featureType: 'transit.line',
        elementType: 'geometry.fill',
        stylers: [{
          color: '#283d6a'
        }]
      }, {
        featureType: 'transit.station',
        elementType: 'geometry',
        stylers: [{
          color: '#3a4762'
        }]
      }, {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{
          color: '#0e1626'
        }]
      }, {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#4e6d70'
        }]
      }];
    } else if (mapArray.mapstyle == 'retro') {
      styleJson = [{
        elementType: 'geometry',
        stylers: [{
          color: '#ebe3cd'
        }]
      }, {
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#523735'
        }]
      }, {
        elementType: 'labels.text.stroke',
        stylers: [{
          color: '#f5f1e6'
        }]
      }, {
        featureType: 'administrative',
        elementType: 'geometry.stroke',
        stylers: [{
          color: '#c9b2a6'
        }]
      }, {
        featureType: 'administrative.land_parcel',
        elementType: 'geometry.stroke',
        stylers: [{
          color: '#dcd2be'
        }]
      }, {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#ae9e90'
        }]
      }, {
        featureType: 'landscape.natural',
        elementType: 'geometry',
        stylers: [{
          color: '#dfd2ae'
        }]
      }, {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{
          color: '#dfd2ae'
        }]
      }, {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#93817c'
        }]
      }, {
        featureType: 'poi.park',
        elementType: 'geometry.fill',
        stylers: [{
          color: '#a5b076'
        }]
      }, {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#447530'
        }]
      }, {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{
          color: '#f5f1e6'
        }]
      }, {
        featureType: 'road.arterial',
        elementType: 'geometry',
        stylers: [{
          color: '#fdfcf8'
        }]
      }, {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{
          color: '#f8c967'
        }]
      }, {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [{
          color: '#e9bc62'
        }]
      }, {
        featureType: 'road.highway.controlled_access',
        elementType: 'geometry',
        stylers: [{
          color: '#e98d58'
        }]
      }, {
        featureType: 'road.highway.controlled_access',
        elementType: 'geometry.stroke',
        stylers: [{
          color: '#db8555'
        }]
      }, {
        featureType: 'road.local',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#806b63'
        }]
      }, {
        featureType: 'transit.line',
        elementType: 'geometry',
        stylers: [{
          color: '#dfd2ae'
        }]
      }, {
        featureType: 'transit.line',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#8f7d77'
        }]
      }, {
        featureType: 'transit.line',
        elementType: 'labels.text.stroke',
        stylers: [{
          color: '#ebe3cd'
        }]
      }, {
        featureType: 'transit.station',
        elementType: 'geometry',
        stylers: [{
          color: '#dfd2ae'
        }]
      }, {
        featureType: 'water',
        elementType: 'geometry.fill',
        stylers: [{
          color: '#b9d3c2'
        }]
      }, {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#92998d'
        }]
      }];
    } else if (mapArray.mapstyle == 'silver') {
      styleJson = [{
        elementType: 'geometry',
        stylers: [{
          color: '#f5f5f5'
        }]
      }, {
        elementType: 'labels.icon',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#616161'
        }]
      }, {
        elementType: 'labels.text.stroke',
        stylers: [{
          color: '#f5f5f5'
        }]
      }, {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#bdbdbd'
        }]
      }, {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{
          color: '#eeeeee'
        }]
      }, {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#757575'
        }]
      }, {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{
          color: '#e5e5e5'
        }]
      }, {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#9e9e9e'
        }]
      }, {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{
          color: '#ffffff'
        }]
      }, {
        featureType: 'road.arterial',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#757575'
        }]
      }, {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{
          color: '#dadada'
        }]
      }, {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#616161'
        }]
      }, {
        featureType: 'road.local',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#9e9e9e'
        }]
      }, {
        featureType: 'transit.line',
        elementType: 'geometry',
        stylers: [{
          color: '#e5e5e5'
        }]
      }, {
        featureType: 'transit.station',
        elementType: 'geometry',
        stylers: [{
          color: '#eeeeee'
        }]
      }, {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{
          color: '#c9c9c9'
        }]
      }, {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#9e9e9e'
        }]
      }];
    } else if (mapArray.mapstyle == 'night') {
      styleJson = [{
        elementType: 'geometry',
        stylers: [{
          color: '#242f3e'
        }]
      }, {
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#746855'
        }]
      }, {
        elementType: 'labels.text.stroke',
        stylers: [{
          color: '#242f3e'
        }]
      }, {
        featureType: 'administrative.locality',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#d59563'
        }]
      }, {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#d59563'
        }]
      }, {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{
          color: '#263c3f'
        }]
      }, {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#6b9a76'
        }]
      }, {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{
          color: '#38414e'
        }]
      }, {
        featureType: 'road',
        elementType: 'geometry.stroke',
        stylers: [{
          color: '#212a37'
        }]
      }, {
        featureType: 'road',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#9ca5b3'
        }]
      }, {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{
          color: '#746855'
        }]
      }, {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [{
          color: '#1f2835'
        }]
      }, {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#f3d19c'
        }]
      }, {
        featureType: 'transit',
        elementType: 'geometry',
        stylers: [{
          color: '#2f3948'
        }]
      }, {
        featureType: 'transit.station',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#d59563'
        }]
      }, {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{
          color: '#17263c'
        }]
      }, {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#515c6d'
        }]
      }, {
        featureType: 'water',
        elementType: 'labels.text.stroke',
        stylers: [{
          color: '#17263c'
        }]
      }];
    } else {
      styleJson = [];
    } //Create google maps link


    $('.js-map-link').attr('href', 'https://www.google.com/maps/place/' + mapArray.directions + '/@' + lat + ',' + lng); //Set map options

    var mapOptions = {
      zoom: mapArray.zoom,
      center: location,
      styles: styleJson,
      disableDefaultUI: false
    }; //Create map

    var map = new google.maps.Map(document.getElementById(mapArray.sectionid), mapOptions); //Show pin

    if (mapArray.showpin == true) {
      var marker = new google.maps.Marker({
        position: location,
        map: map
      });
    }
  }
};
/*============================================================================
  Collection template
==============================================================================*/

Theme.collection = {
  init: function init() {
    if ($('.masonry--true').length) {
      Theme.collection.applyMasonry();
    }

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      $(".quickShop").remove();
    } else {
      // If on desktop device and show secondary media setting enabled, run thumbnail hover logic
      if (window.Shopify.theme_settings.collection_secondary_image) {
        $('.has-secondary-media-swap').on('mouseenter', function () {
          $(this).find('.image-element__wrap img').toggleClass('secondary-media-hidden');
          $(this).find('[data-html5-video]').toggleClass('secondary-media-hidden');
          $(this).find('.external-video__container').toggleClass('secondary-media-hidden');
          videoFeature.enableVideoOnHover($(this));
        });
        $('.has-secondary-media-swap').on('mouseleave', function () {
          $(this).find('.image-element__wrap img').toggleClass('secondary-media-hidden');
          $(this).find('[data-html5-video]').toggleClass('secondary-media-hidden');
          $(this).find('.external-video__container').toggleClass('secondary-media-hidden');
          videoFeature.disableVideoOnHover($(this));
        });
      }
    }
  },
  applyMasonry: function applyMasonry() {
    if ($('.collection__container').data('collection-count') > 3 && $('.collection__container').data('collection-masonry') == true) {
      var $grid = $('.collection-template-section .collection__grid').isotope({
        layoutMode: 'masonry',
        percentPosition: true,
        itemSelector: '.product__gridItem',
        masonry: {
          columnWidth: '.product__thumbnail'
        }
      });
      $grid.imagesLoaded().progress(function () {
        $grid.isotope('layout');
      });
    }
  },
  unload: function unload($target) {
    var $grid = $target.find('.collection__grid').isotope();
    $grid.isotope('destroy');
  }
};
/*============================================================================
  Product page
==============================================================================*/

Theme.productPage = {
  init: function init() {
    var _bindUIDraggableEvents;

    if (window.Shopify.theme_settings.enable_quickshop) {
      Theme.quickShop.unload();
      Theme.quickShop.init();
    }

    $('select').each(function () {
      $(this).attr('tabindex', 0);
    }); // Hover to zoom

    var zoom = $('.product_gallery').data('zoom');

    if (zoom === true) {
      document.addEventListener('lazybeforeunveil', Theme.imageFunctions.enableZoom);
    } // function to check if browser is IE


    var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./); // Ensure product media libraries are present

    if (!isIE11) {
      window.Shopify.loadFeatures([{
        name: 'model-viewer',
        version: '0.8'
      }, {
        name: 'shopify-xr',
        version: '1.0'
      }, {
        name: 'model-viewer-ui',
        version: '1.0'
      }], productMedia.setupMedia);
    } // Select all product galleries on page


    var $productGalleries = $(':not(.gallery-loaded)[data-product-gallery]'); // Logic below will execute on each product gallery found

    if ($productGalleries.length > 0) {
      $.each($productGalleries, function (index, gallery) {
        var $el = $(gallery);
        var $slides = $el.find('.gallery-cell');
        $el.addClass('gallery-loaded');
        $el.on('ready.flickity', function () {
          $slides.each(function (index, slide) {
            //Determine media type
            var mediaType = $(slide).data('media-type');
            $.each(videoPlayers, function (index, player) {
              if (!$(slide).hasClass('is-selected')) {
                player.keyboard = {
                  focused: false,
                  global: false
                };
              }
            });

            switch (mediaType) {
              case 'model':
                if ($(slide).hasClass('is-selected')) {
                  //When active slide
                  if (mediaType == 'model' && Theme.utils.isScreenSizeLarge()) {
                    $(slide).on('mouseenter', function () {
                      $el.flickity('unbindDrag');
                    });
                    $(slide).on('mouseleave', function () {
                      $el.flickity('bindDrag');
                    });
                  }
                }

            }
          });
        });
        var draggable, prevNextButtons;
        var autoplay = $(gallery).data('autoplay');
        var prevNextButtons = $(gallery).data('show-arrows');

        if ($(gallery).find('.gallery-cell').length == 1) {
          draggable = false;
          $(gallery).addClass('single-image');
        } else {
          draggable = true;
        }

        $el.flickity({
          "wrapAround": "true",
          "cellAlign": "left",
          "draggable": draggable,
          "contain": true,
          "imagesLoaded": true,
          "lazyLoad": 2,
          "pageDots": false,
          "prevNextButtons": prevNextButtons && $el.data('media-count') > 1 ? true : false,
          "autoPlay": autoplay * 1000,
          "selectedAttraction": 0.01,
          "dragThreshold": 15,
          "adaptiveHeight": true,
          "arrowShape": 'M8.24174152,52.1419562 C7.78636981,51.7324871 7.50000006,51.1387651 7.50000006,50.478158 L7.50000113,50.4759409 C7.49942646,49.9027311 7.71781139,49.3293425 8.1551559,48.891998 L39.4709454,17.5762085 C40.3444866,16.7026673 41.7607767,16.7026673 42.6343179,17.5762085 C43.5078591,18.4497497 43.5078591,19.8660399 42.6343179,20.7395811 L15.1325831,48.2413159 L90.263158,48.2413159 C91.4985317,48.2413159 92.5000001,49.2427843 92.5000001,50.478158 C92.5000001,51.7135316 91.4985317,52.7150001 90.263158,52.7150001 L15.1415305,52.7150001 L42.6343179,80.2077875 C43.5078591,81.0813287 43.5078591,82.4976188 42.6343179,83.37116 C41.7607767,84.2447011 40.3444866,84.2447011 39.4709454,83.37116 L8.24174152,52.1419562 Z'
        });
        $el.on('change.flickity', function () {
          $slides.each(function (index, slide) {
            //Determine media type of current slide
            var mediaType = $(slide).data('media-type');

            if ($(slide).hasClass('is-selected')) {
              //When active slide
              switch (mediaType) {
                case 'model':
                  /* On slide change, if active slide contains 3d model
                  * If on desktop, on hover, unbind flickity, after hover bind flickity
                  * On model play event, unbind flickity to ensure model can be interacted with
                  * On model pause event, bind flickity so that slide can be swiped
                  * Pause all model slides when hidden
                  */
                  if (Theme.utils.isScreenSizeLarge()) {
                    // On mouseenter event, unbind flickity
                    $(slide).on('mouseenter', function () {
                      $el.flickity('unbindDrag');
                    }); // On mouseleave event, bind flickity

                    $(slide).on('mouseleave', function () {
                      $el.flickity('bindDrag');
                    });
                  } // Listen for model pause/play events


                  $(slide).find('model-viewer').on('shopify_model_viewer_ui_toggle_play', function () {
                    $el.flickity('unbindDrag');
                  });
                  $(slide).find('model-viewer').on('shopify_model_viewer_ui_toggle_pause', function () {
                    $el.flickity('bindDrag');
                  });
                  break;

                default:
                  $el.flickity('bindDrag');
              }
            } else {
              //When inactive slide
              switch (mediaType) {
                case 'external_video':
                  //Youtube video pausing
                  $.each(videoPlayers, function (index, player) {
                    player.pause();
                  });
                  break;

                case 'video':
                  //HTML5 video pausing
                  $.each(videoPlayers, function (index, player) {
                    player.pause();
                  });
                  break;

                case 'model':
                  $.each(models, function (index, model) {
                    model.pause();
                  });
              }
            }
          }); //Restore 3d model icons

          productMedia.showModelIcon($el);
        });
        setTimeout(function () {
          $el.flickity('resize');
        }, 500);
        $(window).on('load', function () {
          $el.flickity('resize');
        }); // Checks for videos and plays them if they are the featured media
        // Autoplay logic only happens on desktop, autoplay set to off for mobile

        var $sliderArrows = $el.find('.flickity-prev-next-button');
        var $thumbnails = $el.parents('.js-product-page-gallery').find('.product_gallery_nav .gallery-cell');
        var pId = $el.data('product-id');

        if (($sliderArrows || $thumbnails) && Theme.utils.isScreenSizeLarge()) {
          $sliderArrows.on('click', function () {
            $el.on('settle.flickity', function (event, index) {
              // Find out media type of featured media slide
              var mediaType = $el.find('.gallery-cell.is-selected').data('media-type'); // Run video autoplay logic if featured media is a video

              if (mediaType == 'video' || mediaType == 'external_video') {
                checkForVideos();
              } // Autoplay model if featured media is a model


              if (mediaType == 'model') {
                // If model container has class is-selected then play the model
                var sortedModels = [];
                $.each(models, function (index, model) {
                  if ($(model.container).closest('.gallery-cell').data('product-id') == pId) {
                    sortedModels.push(model);
                  }
                });
                $.each(sortedModels, function (index, model) {
                  var $slide = $(model.container).closest('.gallery-cell');

                  if ($slide.hasClass('is-selected')) {
                    model.play();
                  }
                });
              }

              $el.off('settle.flickity');
            });
            return false;
          });
          $thumbnails.on('click', function (event) {
            var index = $(event.currentTarget).index();
            $el.flickity('select', index);
            $el.on('settle.flickity', function (event, index) {
              // Find out media type of featured media slide
              var mediaType = $el.find('.gallery-cell.is-selected').data('media-type'); // Run video autoplay logic if featured media is a video

              if (mediaType == 'video' || mediaType == 'external_video') {
                checkForVideos();
              } // Autoplay model if featured media is a model


              if (mediaType == 'model') {
                // If model container has class is-selected then play the model
                var sortedModels = [];
                $.each(models, function (index, model) {
                  if ($(model.container).closest('.gallery-cell').data('product-id') == pId) {
                    sortedModels.push(model);
                  }
                });
                $.each(sortedModels, function (index, model) {
                  var $slide = $(model.container).closest('.gallery-cell');

                  if ($slide.hasClass('is-selected')) {
                    model.play();
                  }
                });
              }

              $el.off('settle.flickity');
            });
            return false;
          });
          $thumbnails.keypress(function (event) {
            if (event.which == 13) {
              var index = $(event.currentTarget).index();
              $el.flickity('select', index);
              var $selectedSlide = $el.find('.gallery-cell.is-selected');
              $el.on('settle.flickity', function (event, index) {
                $selectedSlide.find('[data-youtube-video]').attr('tabindex', '0');
                $selectedSlide.find('model-viewer, .plyr, a').focus();
                $el.off('settle.flickity');
              }); // Find out media type of featured media slide

              var mediaType = $selectedSlide.data('media-type'); // Run video autoplay logic if featured media is a video

              if (mediaType == 'video' || mediaType == 'external_video') {
                checkForVideos();
              } // Autoplay model if featured media is a model


              if (mediaType == 'model') {
                // If model container has class is-selected then play the model
                var sortedModels = [];
                $.each(models, function (index, model) {
                  if ($(model.container).closest('.gallery-cell').data('product-id') == pId) {
                    sortedModels.push(model);
                  }
                });
                $.each(sortedModels, function (index, model) {
                  var $slide = $(model.container).closest('.gallery-cell');

                  if ($slide.hasClass('is-selected')) {
                    model.play();
                  }
                });
              }

              return false;
            }
          });
        }

        function checkForVideos() {
          $slides.each(function (index, slide) {
            // Variables
            var $slide = $(slide);
            var mediaType = $slide.data('media-type');
            var videoID = $slide.find('video').data('plyr-video-id');
            var $iframeVideo = $slide.find('iframe');
            var iframeID = $iframeVideo.attr('id');

            if ($slide.hasClass('is-selected')) {
              if (mediaType == 'video') {
                videoID = $slide.find('video').data('plyr-video-id');

                if (videoID) {
                  autoplayVideo(videoID, $slide);
                }
              } else if (mediaType == 'external_video') {
                if (iframeID) {
                  autoplayYoutubeVideo(iframeID, $slide);
                }
              }
            }
          });
        }

        function autoplayVideo(videoID, $slide) {
          // Compare id to player object and only play that video
          $.each(videoPlayers, function (index, player) {
            if (player.id == videoID) {
              player.play(); // On fullscreen toggle, focus back on the slide itself

              player.on('exitfullscreen', function () {
                $slide.closest('.gallery-wrap').find('.product_gallery_nav').focus();
              });
            }
          });
        }

        function autoplayYoutubeVideo(iframeID, $slide) {
          // compare id to player object and only play that video
          $.each(videoPlayers, function (index, player) {
            if (player.playing) {
              player.pause();
            }

            if (player.media !== null) {
              if (player.media.id == iframeID) {
                player.play(); // On fullscreen toggle, focus back on the slide itself

                player.on('exitfullscreen', function () {
                  $slide.closest('.gallery-wrap').find('.product_gallery_nav').focus();
                });
              }
            }
          });
        }

        var groupCells, navPrevNextButtons, navCellAlign;
        var galleryWrap = $(gallery).closest('.js-product-page-gallery');

        if ($(galleryWrap).find('.product_gallery_nav .gallery-cell').length > 6) {
          groupCells = false;
          navPrevNextButtons = true;
          navCellAlign = "left";
          $(galleryWrap).find('.product_gallery_nav').removeClass('no-border');
        } else {
          navCellAlign = "center";
        }

        if ($(galleryWrap).find('.product_gallery_nav').length > 0) {
          if ($(galleryWrap).find('.product_gallery_nav--left-thumbnails, .product_gallery_nav--right-thumbnails').length > 0) {
            $(galleryWrap).find('.product_gallery_nav').addClass('vertical-slider-enabled');
            $(galleryWrap).find('.product_gallery_nav .gallery-cell').on('click', function (event) {
              var index = $(event.currentTarget).index();
              $el.flickity('select', index);
            });
            var navCellHeight = $(galleryWrap).find('.product_gallery_nav .gallery-cell').height();
            var navHeight = $(galleryWrap).find('.product_gallery_nav').height();
            $el.on('select.flickity', function () {
              // set selected nav cell
              var flkty = $el.data('flickity');
              $(galleryWrap).find('.product_gallery_nav').find('.is-nav-selected').removeClass('is-nav-selected');
              var $selected = $('.product_gallery_nav .gallery-cell').eq(flkty.selectedIndex).addClass('is-nav-selected'); // scroll nav

              var scrollY = $selected.position().top + $('.product_gallery_nav .gallery-cell').scrollTop() - (navHeight + navCellHeight) / 2;
              $(galleryWrap).find('.product_gallery_nav').animate({
                scrollTop: scrollY
              });
            });
          } else {
            if ($('.product-nav-slider--true').length > 0) {
              var navOptions = {
                "asNavFor": gallery,
                "cellAlign": navCellAlign,
                "contain": true,
                "lazyLoad": 2,
                "draggable": true,
                "pageDots": false,
                "prevNextButtons": navPrevNextButtons,
                "groupCells": groupCells,
                "arrowShape": 'M8.24174152,52.1419562 C7.78636981,51.7324871 7.50000006,51.1387651 7.50000006,50.478158 L7.50000113,50.4759409 C7.49942646,49.9027311 7.71781139,49.3293425 8.1551559,48.891998 L39.4709454,17.5762085 C40.3444866,16.7026673 41.7607767,16.7026673 42.6343179,17.5762085 C43.5078591,18.4497497 43.5078591,19.8660399 42.6343179,20.7395811 L15.1325831,48.2413159 L90.263158,48.2413159 C91.4985317,48.2413159 92.5000001,49.2427843 92.5000001,50.478158 C92.5000001,51.7135316 91.4985317,52.7150001 90.263158,52.7150001 L15.1415305,52.7150001 L42.6343179,80.2077875 C43.5078591,81.0813287 43.5078591,82.4976188 42.6343179,83.37116 C41.7607767,84.2447011 40.3444866,84.2447011 39.4709454,83.37116 L8.24174152,52.1419562 Z'
              };
              $(galleryWrap).find('.product_gallery_nav').flickity(navOptions);
              var isDisabled = $(galleryWrap).find('.product_gallery_nav .flickity-prev-next-button.next').prop('disabled');

              if (isDisabled) {
                $(galleryWrap).find('.product_gallery_nav').addClass('no-slide');
                navOptions.draggable = false;
              }
            } else {
              $el.on('select.flickity', function () {
                // set selected nav cell
                var flkty = $el.data('flickity');
                $(galleryWrap).find('.product_gallery_nav').find('.is-nav-selected').removeClass('is-nav-selected');
                var $selected = $('.product_gallery_nav .gallery-cell').eq(flkty.selectedIndex).addClass('is-nav-selected'); // scroll nav

                var scrollY = $selected.position().top + $('.product_gallery_nav .gallery-cell').scrollTop() - (navHeight + navCellHeight) / 2;
                $(galleryWrap).find('.product_gallery_nav').animate({
                  scrollTop: scrollY
                });
              });
            }
          }
        }
      });
    }

    var $defaultSelector = $('.js-product_section [data-product-form]:not(.product-recommendations .js-product_section [data-product-form])');
    $defaultSelector.each(function (_, options) {
      var $options = $(options);
      var $productDetailsEl = $options.closest('.product__details');
      var paymentTerms = new _helpers_PaymentTerms__WEBPACK_IMPORTED_MODULE_0__/* .default */ .Z($productDetailsEl[0]);
      var surfacePickUpEl = $productDetailsEl.find('[data-surface-pick-up]')[0];
      var productTitle = $options.data('product-title');
      var currentVariantId = $options.data('variant-id');
      var surfacePickUp;

      if (surfacePickUpEl) {
        surfacePickUp = new _pixelunion_shopify_surface_pick_up__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z(surfacePickUpEl);
        surfacePickUp.load(currentVariantId);
        surfacePickUp.onModalRequest(function (contents) {
          var surfacePickUpModal = document.querySelector('[data-surface-pick-up-modal]');
          var fragment; // Build out pop-up content for product with no variants, else build
          // out popup content for product with variants

          if (!window.currentVariant && productTitle) {
            fragment = document.createDocumentFragment();
            var header = document.createElement('div');
            var title = document.createElement('h2');
            header.classList.add('surface-pick-up__modal-header');
            title.classList.add('surface-pick-up__modal-title');
            title.innerHTML = productTitle;
            header.appendChild(title);
            fragment.appendChild(header);
          } else if (window.currentVariant.title && productTitle) {
            fragment = document.createDocumentFragment();

            var _header = document.createElement('div');

            var _title = document.createElement('h2');

            _header.classList.add('surface-pick-up__modal-header');

            _title.classList.add('surface-pick-up__modal-title');

            _title.innerHTML = productTitle;

            _header.appendChild(_title);

            if (window.currentVariant.title !== 'Default Title') {
              var subtitle = document.createElement('span');
              subtitle.classList.add('surface-pick-up__modal-subtitle');
              subtitle.innerHTML = window.currentVariant.title;

              _header.appendChild(subtitle);
            }

            fragment.appendChild(_header);
          }

          surfacePickUpModal.innerHTML = contents;
          surfacePickUpModal.insertBefore(fragment, surfacePickUpModal.firstChild);
          $.fancybox.open(surfacePickUpModal, {
            hash: false,
            infobar: false,
            toolbar: false,
            loop: true,
            smallBtn: true,
            touch: false,
            video: {
              autoStart: false
            },
            mobile: {
              preventCaptionOverlap: false,
              toolbar: true
            }
          });
        });
      }

      var selectId = $options.data('select-id');

      if (document.getElementById(selectId) && $options.find('.selector-wrapper').length === 0) {
        new window.Shopify.OptionSelectors($options.data('select-id'), {
          product: $options.data('product'),
          onVariantSelected: function onVariantSelected(variant, selector) {
            window.currentVariant = variant;
            paymentTerms.update(variant ? variant.id : null);

            if (surfacePickUp) {
              surfacePickUp.load(variant ? variant.id : null);
            }

            Theme.selectCallback(variant, selector);
          },
          enableHistoryState: $options.data('enable-state')
        });
      }
    });

    if (window.Shopify.theme_settings.product_form_style == "swatches") {
      $('body').on('click', '.swatch :radio', function () {
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();
        $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
      }); //Swatches linked with selected options

      if ($('.js-product_section').length) {
        var $productForms = $('.js-product_section').find('.product_form'); //Loop through each product and set the initial option value state

        $productForms.each(function () {
          var JSONData = $(this).data('product');
          var productID = $(this).data('product-id');
          var productSection = '.product-' + productID + '.js-product_section';
          var swatchOptions = $(this).find('.swatch_options .swatch');

          if (swatchOptions.length > 1) {
            window.Shopify.linkOptionSelectors(JSONData, productSection);
          }
        });
      } //Add click event when there is more than one product on the page (eg. Collection in Detail)


      if ($('.js-product_section').length > 1) {
        $('body').on('click', '.swatch-element', function () {
          var swatchValue = $(this).data('value').toString();
          $(this).siblings('input[value="' + swatchValue.replace(/\"/g, '\\"') + '"]').prop("checked", true).trigger("change");
          var JSONData = $(this).parents('.product_form').data('product');
          var productID = $(this).parents('.product_form').data('product-id');
          var productSection = '.product-' + productID + '.js-product_section';
          var swatchOptions = $(this).parents('.product_form').find('.swatch_options .swatch');

          if (swatchOptions.length > 1) {
            window.Shopify.linkOptionSelectors(JSONData, productSection);
          }
        });
      }
    }
  },
  loadProductRecommendations: function loadProductRecommendations() {
    var $productRecommendationsContainer = $('.product-recommendations');

    if ($productRecommendationsContainer.length === 0) {
      return false;
    }

    var productID = $productRecommendationsContainer.data('product-id');
    var limit = $productRecommendationsContainer.data('limit'); // Build request URL

    var recommendationsURL = $productRecommendationsContainer.data('recommendations-url');
    var requestUrl = recommendationsURL + "?section_id=product-recommendations&limit=" + limit + "&product_id=" + productID;
    $.ajax({
      type: 'GET',
      url: requestUrl,
      success: function success(data) {
        var $recommendedProductsElement = $(data).find('.product-recommendations').html(); // Insert product list into the product recommendations container

        $productRecommendationsContainer.html($recommendedProductsElement);
        $productRecommendationsContainer.addClass('recommendations-loaded');
        Theme.collection.unload($('.recommended-products-section'));
        Theme.collection.init();
        Theme.productPage.init();

        if (Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
      }
    });
  },
  enableStickyCartButton: function enableStickyCartButton() {
    $('.purchase--sticky').addClass('sticky--enabled').removeClass('hidden');
    $('.sticky--enabled').unstickFooter({
      trigger: '.footer-section'
    });
  },
  disableStickyCartButton: function disableStickyCartButton() {
    $('.sticky--enabled').addClass('hidden');
  },
  unload: function unload($target) {
    var $slider = $target.find('.products-slider');
    $slider.flickity('destroy');
  }
};
/*============================================================================
  Gallery page
==============================================================================*/

Theme.galleryPage = {
  init: function init() {
    window.onload = function () {
      Theme.galleryPage.enableGrid(); // bind filter button click

      $('.filters-button-group').on('click', 'button', function () {
        $('.button__group .is-checked').removeClass('is-checked');
        $(this).addClass('is-checked');
        var filterValue = $(this).attr('data-filter');
        var classFilter = '.' + filterValue;
        $('.gallery__section').isotope({
          filter: classFilter
        });
      });
    };
  },
  enableGrid: function enableGrid() {
    if (window.Shopify.media_queries.large.matches) {
      var $grid = $('.gallery__section').isotope({
        layoutMode: $('.gallery__content').data('gallery-type'),
        itemSelector: '.gallery__item',
        masonry: {
          gutter: 0
        },
        fitRows: {
          gutter: 0
        }
      });
    } else {
      var $grid = $('.gallery__section').isotope();
    }
  },
  unload: function unload($target) {
    var $grid = $('.gallery__section').isotope();
    $grid.isotope('destroy');
    $('.filters-button-group').off('click');
  }
};
/*============================================================================
  Filter Products with AJAX
==============================================================================*/

Shopify.queryParams = {};

if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');

    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}

var quickFilter = {
  init: function init() {
    var selectedOptions = [],
        query = '',
        currentTags = '',
        siteUrl = 'https://' + $.url('hostname'),
        url1 = $.url('1') ? '/' + $.url('1') + '/' : '',
        url2 = $.url('2') ? $.url('2') + '/' : '',
        url3 = $.url('3'),
        path = url1 + url2; //Handle dropdowns if they exist

    if ($('#sort-by').length) {
      query = $('#sort-by').val();
    } else {
      query = url('?sort_by');
    }

    if ($('#tag_filter').length) {
      if ($('#tag_filter').data('default-collection') != $('#tag_filter').val()) {
        var urlTag = $('#tag_filter').val().substr($('#tag_filter').val().lastIndexOf('/') + 1);

        if (urlTag != 'all') {
          if ($.inArray(urlTag, selectedOptions) > -1) {//Do nothing
          } else {
            selectedOptions.unshift(urlTag);
          }
        }
      }
    } //Add all checkbox values to array


    $('[data-option-filter] input:checked').each(function () {
      selectedOptions.push($(this).val());
    });
    selectedOptions = $.makeArray(selectedOptions); //Loop through tags to create string to update page url

    $.each(selectedOptions, function (i, value) {
      if (i != selectedOptions.length - 1) {
        currentTags += selectedOptions[i] + '+';
      } else {
        currentTags += selectedOptions[i];
      }
    });
    Shopify.queryParams.sort_by = query;
    query = '?' + $.param(Shopify.queryParams);
    quickFilter.processUrl(path, currentTags, query);
  },
  updateView: function updateView(filterURL) {
    $.ajax({
      type: 'GET',
      url: filterURL,
      beforeSend: function beforeSend() {
        $(".collection-matrix").addClass('fadeOut animated loading-in-progress');
      },
      success: function success(data) {},
      error: function error(x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
        location.replace(location.protocol + '//' + location.host + filterURL);
      },
      dataType: "html"
    }).then(function (data) {
      $(".collection-matrix").removeClass('loading-in-progress');
      var filteredBreadcrumb = $(data).find('.breadcrumb_text').html();
      $('.breadcrumb_text').html(filteredBreadcrumb);
      var filteredPagination = $(data).find('.paginate').html();
      $('.paginate').html(filteredPagination);
      var filteredSidebar = $(data).find('.sidebar').html();
      $('.sidebar').html(filteredSidebar);
      var filteredPageLinks = $(data).find('.paginate').html();
      $('.paginate').empty();
      $('.paginate').html(filteredPageLinks);
      var filteredData = $(data).find('.collection-matrix');
      var collectionContainer = $('.collection-matrix').parent();
      $('.collection-matrix').remove();
      filteredData.prependTo(collectionContainer);
      window.history && window.history.pushState && window.history.pushState("", "", filterURL);

      if ($('.masonry--true').length) {
        setTimeout(function () {
          Theme.collection.applyMasonry();
        }, 100);
      }

      if (window.Shopify.theme_settings.enable_shopify_collection_badges && window.Shopify.theme_settings.enable_shopify_review_comments) {
        Theme.utils.renderReviews();
      }
    });
  },
  processUrl: function processUrl(path, tags, query) {
    var query = query.replace(/\page=(\w+)&/, ''),
        urlString = '';
    urlString = path + tags + query;
    quickFilter.updateView(urlString);
  }
};
$('#sort-by').val($('#sort-by').data('default-sort'));
$('body').on('change', '#tag_filter, #sort-by', function () {
  quickFilter.init();
});
$('body').on('change', '#blog_filter', function () {
  var url = $(this).val();
  window.location = url;
});
$('input, select, textarea').on('focus blur', function (event) {
  $('meta[name=viewport]').attr('content', 'width=device-width,initial-scale=1,maximum-scale=' + (event.type == 'blur' ? 10 : 1));
});
/*============================================================================
  FAQ
==============================================================================*/

Theme.faqAccordion = {
  init: function init() {
    var flg = 0;
    var $faqHeading = $('.faqAccordion > dt > button');
    $('.faqAccordion > dd').attr('aria-hidden', true);
    $faqHeading.attr('aria-expanded', false);
    $faqHeading.on('click activate', function () {
      if (flg) return false;
      flg = 1;
      var state = $(this).attr('aria-expanded') === 'false' ? true : false;
      $(this).attr('aria-expanded', state);
      $(this).parent().next().slideToggle(function () {
        flg = 0;
      });
      $(this).parent().next().attr('aria-hidden', !state);
      return false;
    });
    $faqHeading.on('keydown', function (event) {
      var keyCode = event.keyCode || e.which;

      if (keyCode === 13) {
        $(this).trigger('activate');
      }
    });
  },
  unload: function unload($target) {
    $('.faqAccordion > dt > button').off('click activate');
    $('.faqAccordion > dt > button').off('keydown');
  }
};
/*============================================================================
  Utilities
==============================================================================*/

Theme.rellax;
Theme.shapes = {
  init: function init() {
    if ($('.parallax-shape').length) {
      if ($(window).height() !== 0) {
        Theme.rellax = new Rellax('.parallax-shape');
      } else {
        $('.parallax-shape').removeAttr('style');
        Theme.windowTimer = setInterval(Theme.shapes.checkWindowHeight, 100);
      }
    }
  },
  checkWindowHeight: function checkWindowHeight() {
    if ($(window).height() > 0) {
      Theme.shapes.init();
      clearInterval(Theme.windowTimer);
    }
  },
  unload: function unload($target) {
    if ($('.parallax-shape').length) {
      Theme.rellax.destroy();
    }
  }
};
Theme.utils = {
  animationOnScroll: function animationOnScroll() {
    $('.animateHeader').removeClass('animateHeader--long').removeClass('animateHeader--short').removeClass('animateHeader--horizontal'); // Setup a timer

    var timeout;
    setTimeout(function () {
      $('.sectionHeader').each(function () {
        if ($(this).is(':on-screen')) {
          if (window.Shopify.theme_settings.heading_accent == 'vertical_short') {
            $(this).addClass('animateHeader--short');
          } else if (window.Shopify.theme_settings.heading_accent == 'horizontal') {
            $(this).addClass('animateHeader--horizontal');
          } else if (window.Shopify.theme_settings.heading_accent == 'vertical_long') {
            $(this).addClass('animateHeader--long');
          }
        }
      });
    }, 10); // Listen for resize events

    window.addEventListener('scroll', function (event) {
      // If there's a timer, cancel it
      if (timeout) {
        window.cancelAnimationFrame(timeout);
      } // Setup the new requestAnimationFrame()


      timeout = window.requestAnimationFrame(function () {
        $('.sectionHeader').each(function () {
          if ($(this).is(':on-screen')) {
            if (window.Shopify.theme_settings.heading_accent == 'vertical_short') {
              $(this).addClass('animateHeader--short');
            } else if (window.Shopify.theme_settings.heading_accent == 'horizontal') {
              $(this).addClass('animateHeader--horizontal');
            } else if (window.Shopify.theme_settings.heading_accent == 'vertical_long') {
              $(this).addClass('animateHeader--long');
            }
          }
        });
      });
    }, false);
  },
  addImageDimension: function addImageDimension(imageUrl, size) {
    var insertPosition = imageUrl.lastIndexOf(".");
    return imageUrl.substring(0, insertPosition) + size + imageUrl.substring(insertPosition);
  },
  initializeQuantityBox: function initializeQuantityBox() {
    $('body').on('click', '.js-change-quantity', function () {
      var $this = $(this),
          $input = $(this).siblings('input'),
          val = parseInt($input.val()),
          valMax = 100000000000000000000000000000,
          valMin = $input.attr('min') || 0;

      if ($input.attr('max') != null) {
        valMax = $input.attr('max');
      }

      if (isNaN(val) || val < valMin) {
        $input.val(valMin);
        return false;
      } else if (val > valMax) {
        $input.val(valMax);
        return false;
      }

      if ($this.data('func') == 'plus') {
        if (val < valMax) $input.val(val + 1);
      } else {
        if (val > valMin) $input.val(val - 1);

        if ($this.parents(".cart_item").length) {
          if (val - 1 == 0) {
            $this.closest('.cart_item').addClass('animated fadeOutUp');
          }
        }
      }

      $input.trigger('change');
    });
  },
  renderReviews: function renderReviews() {
    SPR.$(document).ready(function () {
      return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();
    });
  },
  enableDisclosure: function enableDisclosure() {
    var $disclosure = $('[data-disclosure]');
    var $toggle = $('[data-disclosure-toggle]');
    var $disclosureWrap = $('.disclosure__list-wrap'); //Check if current opened menu is offscreen

    function checkOffScreen($openedToggle) {
      if ($openedToggle.siblings('.disclosure__list-wrap').is(':off-right')) {
        $openedToggle.siblings('.disclosure__list-wrap').addClass('disclosure--left');
      }
    }

    function closeDisclosures(ignoreTarget, currentTarget) {
      if (ignoreTarget === true) {
        $toggle.not(currentTarget).removeClass('is-clicked');
        $toggle.not(currentTarget).attr('aria-expanded', 'false');
      } else {
        $toggle.removeClass('is-clicked');
        $toggle.attr('aria-expanded', 'false');
      }

      $disclosureWrap.removeClass('disclosure--left');
    } //Close menus on ESC


    $('body').on('keyup', function (e) {
      if (e.which == '27') {
        closeDisclosures();
      }
    }); //Close menus on hoverout

    $disclosure.on('mouseleave', function (e) {
      closeDisclosures();
    }); //On click/focus event for toggling options

    $toggle.on('mouseenter focus', function (e) {
      //Close all other menus
      closeDisclosures(true, this);
      var $target = $(e.currentTarget);
      $target.attr('aria-expanded', 'true').addClass('is-clicked');
      checkOffScreen($target);
    }); //Mobile toggle logic

    $toggle.on('touchstart', function (e) {
      if (window.Shopify.media_queries.medium.matches || !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        var $target = $(e.currentTarget);
        closeDisclosures(true, this);

        if (!$target.hasClass('is-clicked')) {
          $target.attr('aria-expanded', 'true').addClass('is-clicked');
          checkOffScreen($target);
        } else {
          $target.attr('aria-expanded', 'false').removeClass('is-clicked');
          $disclosureWrap.removeClass('disclosure--left');
        }
      }
    });
  },
  isScreenSizeLarge: function isScreenSizeLarge() {
    if (window.Shopify.media_queries.large.matches) {
      return true;
    }
  },
  is_touch_device: function is_touch_device() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  },
  htmlEncode: function htmlEncode(value) {
    if (value) {
      return $('<div/>').text(value).html();
    } else {
      return '';
    }
  },
  legacyFlexslider: function legacyFlexslider() {
    //backwards compatibility with flexslider
    $('.slider, .flexslider').find('li').unwrap();
    $('.slider, .flexslider').flickity({
      pageDots: true,
      imagesLoaded: true,
      lazyLoad: 2
    });
  },
  initializeTabs: function initializeTabs() {
    $('body').on('click', 'ul.tabs > li > a', function (e) {
      e.preventDefault();
      var contentLocation = $(this).attr('href');

      if (contentLocation.charAt(0) == "#") {
        $('ul.tabs > li > a.active').removeClass('active');
        $(this).addClass('active');
        $(this).parents('ul.tabs').next().find(contentLocation).show().css({
          'display': 'block'
        }).addClass('active').siblings().hide().removeClass('active');
      }
    });
  },
  //check to see if HTML5 video is supported
  supports_video: function supports_video() {
    return !!document.createElement('video').canPlayType;
  },
  createAccordion: function createAccordion(container, tab, content) {
    var $container = $(container);
    var $tab = $(container).find(tab);
    var $content = $(container).find(content);
    var specificTab = container + ' ' + tab; //Check to see if need to rearrange product tabs to create accordion (backwards compatible)

    if (container.indexOf(".accordion-tabs") >= 0) {
      var rearrangedTabs = $.map($tab, function (v, i) {
        return [v, $content[i]];
      });
      $container.empty();
      $.each(rearrangedTabs, function (index, value) {
        $container.append(this);
      });
      $content.removeClass('active');
      $container.find('.active').next().slideToggle();
      tab = container + '> a';
    }

    $(container).children('a').each(function (i, tab) {
      var tab = $(this);
      var tabValue = tab.attr('href'); //get tab id

      tab.attr('data-tab-value', tabValue); //set tab id in data attribute

      tab.removeAttr("href"); //remove href (to prevent url hash update)
    });
    $(container).find(tab + '.active').next().slideToggle();
    $(container).find(tab + '.active').toggleClass('active');
    $(specificTab).on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).next().slideToggle();
    });
  },
  resizeFunction: function resizeFunction() {
    if (Modernizr.mq("screen and (min-width:960px)")) {
      Theme.pricingTable.addHeaderLink();
      Theme.productPage.disableStickyCartButton();
    } else {
      Theme.pricingTable.removeHeaderLink();
      Theme.productPage.enableStickyCartButton();
    }

    if (window.Shopify.media_queries.small.matches) {
      $('.shopify-section--video .video__playButton').addClass('action_button');
    } else {
      $('.shopify-section--video .video__playButton').removeClass('action_button');
    }
  },
  mobileAccordion: function mobileAccordion(container, tab, content) {
    var $container = $(container);
    var $tab = $(container).find(tab);
    var $content = $(container).find(content);
    $(tab + '.active').next().slideToggle();
    $(tab).on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).next().slideToggle();
    });
  },
  mobileParentActiveAccordion: function mobileParentActiveAccordion(container, tab, content) {
    var $container = $(container);
    var $tab = $(container).find(tab);
    var $content = $(container).find(content);
    $(tab + '.active').parent().next().slideToggle();
    $(tab + '.active').parent().children('span').toggleClass('active');
    $(tab).on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).parent().next().slideToggle();
    });
  },
  mobileSlider: function mobileSlider() {
    var $slider = $(this); //initiate the slider

    if (!$slider.hasClass('flickity-enabled')) {
      $('.slider--mobile').flickity({
        prevNextButtons: false,
        wrapAround: true,
        watchCSS: true,
        pageDots: true,
        dragThreshold: 15
      });
    }

    ;
  },
  unload: function unload($target) {
    $('[data-disclosure]').off();
    $('[data-disclosure-toggle]').off();
    $('.disclosure__list-wrap').off();
    $('body').off('click', '.js-change-quantity');
    $('body').off('click', '.toggle-all--true .toggle');
    $('body').off('click', 'ul.tabs > li > a');
    $('li.sublink > a.parent-link--false').off('click');
    $('li.sublink > a.parent-link--true span').off('click');
    $('div.mobileToggle').off('click'); // resets overflow hidden that is set on line 2468

    $('body').css('overflow-y', 'initial');
    $('body').off('click', 'h4.toggle');
    $('body').off('click', '.product__section .accordion-tabs .tabs li > a');
    document.removeEventListener('lazybeforeunveil', Theme.imageFunctions.enableZoom);

    if ($('.slider--mobile').length) {
      $('.slider--mobile').flickity('destroy');
    }
  }
};
var sliderBlock = {
  select: function select($parentSection, blockId) {
    var $blocks = $parentSection.find('.gallery-cell');
    var blockIdsArray = $blocks.map(function () {
      return String($(this).data('block-id'));
    });
    var $slider = $parentSection.find('.js-slideshow.flickity-enabled, .js-homepage-testimonial.flickity-enabled');
    var settings = {
      slideshowTextAnimation: $slider.data('slideshow-text-animation')
    };
    var flkty = $slider.data('flickity');

    if ($slider && flkty !== undefined) {
      $slider.flickity('pausePlayer');

      for (var i = 0; i < blockIdsArray.length; i++) {
        if (blockIdsArray[i] === blockId) {
          var currentSlide = i;

          if (currentSlide !== flkty.selectedIndex) {
            $slider.flickity('select', parseInt(currentSlide), false, true);
          }
        }
      }
    }
  },
  deselect: function deselect($parentSection) {
    var $slider = $parentSection.find('.flexslider').data('flexslider');

    if ($slider) {
      $slider.flickity('unpausePlayer');
    }
  }
};
/*============================================================================
  Video section
==============================================================================*/

Theme.videoSection = {
  init: function init() {
    // Set up plyr for newly embedded video
    var featuredVideos = $('[data-video-element]').get();
    var featuredVideoPlayers = Plyr.setup(featuredVideos, {
      controls: videoControls,
      fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: true
      },
      storage: {
        enabled: false
      }
    }); // Adds plyr video id to video wrapper

    $.each(featuredVideoPlayers, function (index, player) {
      var id = player.id;
      var $video;

      if (player.isHTML5) {
        $video = $(player.elements.wrapper).find('video');
        $video.attr('data-plyr-video-id', id);
      } // When a video is playing, pause any other instances


      player.on('play', function (event) {
        var instance = event.detail.plyr;
        $.each(featuredVideoPlayers, function (index, player) {
          if (instance.id != player.id) {
            player.pause();
          }
        });
      });
    });
    $('[data-video-element]').each(function (index, video) {
      // Variables
      var $video = $(video);
      var $section = $video.parents('.shopify-section').attr('id', id);
      var $videoElement = $section.find($video);
      var $videoWrapper = $videoElement.parents('.video-wrapper');
      var $playButton = $videoWrapper.find('[data-play-button]');
      var $videoText = $videoWrapper.find('[data-video-text]');
      var $videoTextContainer = $videoWrapper.find('[data-video-text-container]');
      var $image = $videoWrapper.find('.video-wrapper__image');
      var $posterImage = $videoWrapper.data('poster-image-uploaded');
      var aspectRatio = $videoWrapper.data('aspect-ratio');
      var id = $videoWrapper.data('video-src');
      var isAutoplay = $videoWrapper.data('autoplay');
      var isLoopingEnabled = $videoWrapper.data('autoloop');
      var isMuted = $videoWrapper.data('mute-video');
      $.each(featuredVideoPlayers, function (index, player) {
        var videoID;
        var playerID;

        if (player.isYouTube || player.isVimeo) {
          var videoID = $videoWrapper.data('video-id');
          var playerID = $(player.elements.original).attr('id');
        } else if (player.isHTML5) {
          var videoID = $videoWrapper.find('[data-plyr-video-id]').data('plyr-video-id');
          var playerID = player.id;
          $videoElement = $section.find('.plyr--video');
        }

        if (playerID == videoID) {
          // Reset play button icon
          $videoWrapper.removeClass('play-button-icon--visible'); // Autoplay

          if (isAutoplay) {
            // If on desktop or player is YouTube/Vimeo
            if (window.Shopify.media_queries.large.matches || player.isYouTube || player.isVimeo) {
              player.autoplay = true; // Hide image

              $image.hide(); // Show video

              $videoElement.show(); // If display text over video unchecked

              if ($videoTextContainer.hasClass('display-text-over-video--false')) {
                $videoText.hide();
              } else {
                $videoText.show();
              } // Keep play button hidden


              $playButton.hide(); // HTML5 Mobile Video
            } else if (window.Shopify.media_queries.medium.matches && player.isHTML5) {
              // Hide image
              $image.hide(); // Show video

              $videoElement.show(); // Display button so that video can be played

              $playButton.show();
              player.on('play', function () {
                // Show video
                $videoElement.show(); // Hide play button

                $playButton.hide();
              });
            }
          } else {
            // If Autoplay disabled
            // If poster image, show image wrapper otherwise hide it
            if ($posterImage) {
              $image.show();
              $videoElement.hide();
            } else {
              $image.hide();
              $videoElement.show();
            }
          } // Clicking image will play video


          $image.on('click', function () {
            // Hide image
            $(this).hide(); // Show video

            $videoElement.show();
            player.play();
          }); // Muted

          if (isMuted) {
            player.muted = true;
          } // Aspect Ratio


          if (aspectRatio) {
            player.ratio = aspectRatio;
          } // Looping


          if (isLoopingEnabled) {
            player.loop = true;
          } // Show Video Controls
          // - video controls get hidden using a css class: '.video-controls-enabled--false'
          // If button exists, hide text and poster


          if ($playButton) {
            $playButton.on('click', function () {
              // Hide image
              $image.hide(); // Show video

              $videoElement.show(); // If display text over video unchecked

              if ($videoTextContainer.hasClass('display-text-over-video--false')) {
                $videoText.hide();
              } else {
                $videoText.show();
              } // Play video


              player.play();
            });
          }

          player.on('play', function () {
            // Hide image
            $image.hide(); // Reset play button icon

            $videoWrapper.removeClass('play-button-icon--visible'); // Show video

            $videoElement.show(); // If display text over video unchecked

            if ($videoTextContainer.hasClass('display-text-over-video--false')) {
              $videoText.hide();
            } else {
              $videoText.show();
            } // Hide play button


            if ($playButton) {
              $playButton.hide();
            }
          }); // If video is paused, play button icon or button must be shown
          // If button text is filled out, use play button
          // If button text is not filled out, use play button icon

          player.on('pause', function () {
            if ($playButton.length > 0) {
              $playButton.show();
              $videoWrapper.removeClass('play-button-icon--visible');
            } else {
              $videoWrapper.addClass('play-button-icon--visible');
            }
          }); // If page loads with video paused and no button showing, show icon

          if (!player.playing && $playButton.is(':hidden') || $playButton.length == 0) {
            $videoWrapper.addClass('play-button-icon--visible');
          }

          return false;
        }
      });
    });
  }
};
/*============================================================================
Product media controls
==============================================================================*/

var models = [];
window.productMedia = {
  setupMedia: function setupMedia() {
    var config = {
      // Default control list
      controls: ['zoom-in', 'zoom-out', 'fullscreen'],
      focusOnPlay: false
    };
    models = [];
    $('model-viewer').each(function (index, model) {
      model = new Shopify.ModelViewerUI(model, config);
      models.push(model);
    });
    $('.product-gallery__model model-viewer').on('mousedown', function () {
      productMedia.hideModelIcon(this);
    });
  },
  showModelIcon: function showModelIcon(slide) {
    $(slide).find('.button--poster, .model-icon-button-control').show();
  },
  hideModelIcon: function hideModelIcon(slide) {
    $(slide).find('.button--poster, .model-icon-button-control').hide();
  }
};
/*============================================================================
Plyr player controls
==============================================================================*/

var videoEl = {
  playButtonIcon: '<button type="button" class="plyr__control plyr__control--overlaid" aria-label="Play, {title}" data-plyr="play"><svg class="play-icon-button-control" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23 20V40L39 29.4248L23 20Z" fill="#323232"/></svg><span class="plyr__sr-only">Play</span></button>',
  playButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Play, {title}" data-plyr="play"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Pause</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span></button>',
  muteButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Mute" data-plyr="mute"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span></button>',
  progressInput: '<div class="plyr__controls__item plyr__progress__container"><div class="plyr__progress"><input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek"><progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress><span role="tooltip" class="plyr__tooltip">00:00</span></div></div>',
  volume: '<div class="plyr__controls__item plyr__volume"><input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume"></div>',
  fullscreen: '<button type="button" class="plyr__controls__item plyr__control" data-plyr="fullscreen"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span></button>'
};
var videoControls = videoEl.playButtonIcon + '<div class="plyr__controls">' + videoEl.playButton + videoEl.progressInput + videoEl.muteButton + videoEl.volume + videoEl.fullscreen + '</div>';
var videoPlayers = [];
window.videoFeature = {
  init: function init() {
    this.setupVideoPlayer();
  },
  setupVideoPlayer: function setupVideoPlayer() {
    var productVideos = document.querySelectorAll('[data-html5-video] video, [data-youtube-video]');
    var setupVideoPlayers = Plyr.setup(productVideos, {
      controls: videoControls,
      ratio: this.aspect_ratio,
      fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: true
      },
      storage: {
        enabled: false
      }
    });
    var videoLooping = $('[data-video-loop]').data('video-loop') || false;
    $.each(setupVideoPlayers, function (index, player) {
      player.loop = videoLooping;
      videoPlayers.push(player);

      if (index + 1 == setupVideoPlayers.length) {
        videoFeature.setupListeners();
      }
    });
  },
  setupListeners: function setupListeners() {
    // Adds plyr video id to video wrapper
    $.each(videoPlayers, function (index, player) {
      var $video;

      if (player.isHTML5) {
        $video = $(player.elements.wrapper).find('video');
        $video.attr('data-plyr-video-id', player.id);
      } // When a video is playing, pause any other instances


      player.on('play', function (event) {
        var instance = event.detail.plyr;
        $.each(videoPlayers, function (index, player) {
          if (instance.id != player.id) {
            player.pause();
          }
        });
      });
    });
  },
  enableVideoOnHover: function enableVideoOnHover($thumbnail) {
    var $html5Video = $thumbnail.find('[data-html5-video]');
    var $youtubeVideo = $thumbnail.find('[data-youtube-video]');
    var videoID;

    if ($html5Video.length > 0) {
      videoID = $html5Video.find('[data-plyr-video-id]').data('plyr-video-id');
    } else if ($youtubeVideo.length > 0) {
      videoID = $youtubeVideo.find('iframe').attr('id');
    }

    if (videoID) {
      $.each(videoPlayers, function (index, player) {
        if (player.id == videoID || player.media.id == videoID) {
          player.toggleControls(true);
          player.muted = true;
          player.play();
        }
      });
    }
  },
  disableVideoOnHover: function disableVideoOnHover($thumbnail) {
    var $html5Video = $thumbnail.find('[data-html5-video]');
    var $youtubeVideo = $thumbnail.find('[data-youtube-video]');
    var videoID;

    if ($html5Video.length > 0) {
      videoID = $html5Video.find('[data-plyr-video-id]').data('plyr-video-id');
    } else if ($youtubeVideo.length > 0) {
      videoID = $youtubeVideo.find('iframe').attr('id');
    }

    if (videoID) {
      $.each(videoPlayers, function (index, player) {
        if (player.id == videoID || player.media.id == videoID) {
          if (player.playing) {
            player.pause();
          }
        }
      });
    }
  }
};

Theme.loadSectionScripts = function ($parentSection) {
  Theme.utils.legacyFlexslider();
  Theme.utils.enableDisclosure();
  Theme.utils.initializeTabs();
  Theme.utils.resizeFunction();
  Theme.utils.createAccordion('.footer__menu', 'div.mobileToggle', 'div.toggle_content');
  Theme.utils.createAccordion('.toggle-all--true', '.toggle', 'ul.toggle_list');
  Theme.utils.createAccordion('.product__section .accordion-tabs', '.tabs li > a', '.tabs-content li');
  Theme.utils.mobileParentActiveAccordion('#mobileMenu', 'li.sublink > a.parent-link--true span', 'li.sublink ul');
  Theme.utils.mobileAccordion('#mobileMenu', 'li.sublink > a.parent-link--false', 'li.sublink ul');
  Theme.utils.mobileSlider();

  if (window.Shopify.theme_settings.heading_animation == true) {
    Theme.utils.animationOnScroll();
  }

  if ($parentSection.hasClass('cart-section')) {
    Theme.cart.init();
  }

  if ($parentSection.hasClass('password-page')) {
    Theme.password.init();
  }

  if ($parentSection.hasClass('pricing-table-section')) {
    Theme.pricingTable.init();
  }

  if ($parentSection.hasClass('faq-section')) {
    Theme.faqAccordion.init();
  }

  if ($parentSection.hasClass('shopify-section--product-details-template')) {
    if ($('.video-wrapper').length) {
      Theme.videoSection.init();
    }

    if ($('.featuredCollection').length) {
      Theme.collection.init();
    }
  }

  if ($parentSection.hasClass('page-details-section')) {
    if ($('.featuredProduct').length || $('.featuredCollection').length) {
      Theme.productPage.init();
      Theme.cart.init();
      Theme.collection.init();
    }

    if ($('.video-wrapper').length) {
      Theme.videoSection.init();
    }

    if ($('.shopify-section--map').length) {
      Theme.map.init();
    }
  }

  if ($parentSection.hasClass('shopify-section--video')) {
    Theme.videoSection.init();
  }

  if ($parentSection.hasClass('shopify-section--slideshow')) {
    Theme.slideshow.init();
  }

  if ($parentSection.hasClass('shopify-section--testimonials')) {
    Theme.testimonials.init();
  }

  if ($parentSection.hasClass('contact-section')) {
    Theme.contactForm.init();
  }

  if ($parentSection.hasClass('shopify-section--map') || $parentSection.hasClass('contact-section')) {
    Theme.map.init();
  }

  if ($parentSection.hasClass('shopify-section--featured-product') || $parentSection.hasClass('shopify-section--featured-collection')) {
    Theme.productPage.init();
    Theme.cart.init();
    Theme.collection.init();
  }

  if ($parentSection.hasClass('shopify-section--product-template')) {
    Theme.productPage.init();
    Theme.cart.init();

    if ($('.recommended-products-section').length) {
      Theme.collection.init();
    }
  }

  if ($parentSection.hasClass('collection-template-section')) {
    Theme.collection.init();

    if (window.Shopify.theme_settings.enable_quickshop) {
      Theme.productPage.init();
      Theme.cart.init();
    }
  }

  if ($parentSection.hasClass('search-template-section')) {
    Theme.collection.init();

    if (window.Shopify.theme_settings.enable_quickshop) {
      Theme.productPage.init();
      Theme.cart.init();
    }
  }

  if ($parentSection.hasClass('shopify-section--article-template')) {
    Theme.article.init();
  }

  if ($parentSection.hasClass('header-section')) {
    Theme.header.init();
  }

  if ($parentSection.hasClass('image-gallery-section')) {
    Theme.galleryPage.init();
  }

  if ($parentSection.hasClass('shapesOption')) {
    Theme.shapes.init();
  }
}; //document ready


$(function () {
  window.lazySizesConfig = window.lazySizesConfig || {};
  lazySizesConfig.expand = 300;
  lazySizesConfig.loadHidden = false;
  var oldFlickityCreate = window.Flickity.prototype._create;

  window.Flickity.prototype._create = function () {
    var that = this;

    if (this.element.addEventListener) {
      this.element.addEventListener('load', function () {
        that.onresize();
      }, true);
    }

    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  };

  Flickity.prototype._createResizeClass = function () {
    this.element.classList.add('flickity-resize');
  };

  Flickity.createMethods.push('_createResizeClass');
  var resize = Flickity.prototype.resize;

  Flickity.prototype.resize = function () {
    this.element.classList.remove('flickity-resize');
    resize.call(this);
    this.element.classList.add('flickity-resize');
  }; // Call to flickity fix for sliders on IOS


  Theme.imageFunctions.flickityIosFix();
  var $parentSection = $('.shopify-section');
  Theme.loadSectionScripts($parentSection);

  if ($('.recommended-products-section').length) {
    Theme.productPage.loadProductRecommendations();
  }

  if ($('.js-quickShop__button--more-options').length) {
    Theme.quickShop.init();
  } //Enable plyr


  videoFeature.init();
  objectFitImages();

  if (window.Shopify.theme_settings.enable_autocomplete) {
    searchAutocomplete.init();
  } // Initialize responsive videos


  enableResponsiveVideoWrapper(); //Lightbox default options
  //https://fancyapps.com/fancybox/3/docs/#options

  $.fancybox.defaults.animationEffect = 'fade';
  $.fancybox.defaults.transitionEffect = 'fade';
  $.fancybox.defaults.hash = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.smallBtn = true;
  $.fancybox.defaults.wheel = false;
  $.fancybox.defaults.live = false;
  $.fancybox.defaults.zoom = false;
  $.fancybox.defaults.mobile.preventCaptionOverlap = false;
  $.fancybox.defaults.mobile.toolbar = true;
  $.fancybox.defaults.mobile.buttons = ['close'];
  $.fancybox.defaults.mobile.clickSlide = 'close';
  $.fancybox.defaults.mobile.clickContent = 'zoom';

  $.fancybox.defaults.afterLoad = function (instance, slide) {
    if (instance.current.type == 'image') {
      slide.$content.wrapInner("<div class='fancybox-image-wrap'></div>");
    }

    if (instance.group.length > 1) {
      slide.$content.find('.fancybox-image-wrap').append('<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev ss-icon" href="javascript:;" data-fancybox-prev><span class="icon-left-caret"></span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next ss-icon" href="javascript:;" data-fancybox-next><span class="icon-right-caret"></span></a>');
    }
  }; // Lightbox effect enabled if reduce motion is not enabled


  $('.lightbox').fancybox(); // Gallery fancybox initialization

  $('[rel="gallery"]').fancybox({
    baseClass: "gallery-section__lightbox",
    clickContent: "nextOrClose"
  }); // // Trigger fancybox flickity product gallery images

  $('.product_gallery .gallery-cell .fancybox').fancybox({
    baseClass: 'product-section__lightbox',
    clickContent: "nextOrClose",
    touch: false,
    beforeShow: function beforeShow() {
      // Grab the fancybox element that is being clicked
      var $fancyboxImageElement = $(this.opts.$orig); // Add alt to fancybox image

      var imageAlt = $fancyboxImageElement.data('alt');
      $('.fancybox-image').attr('alt', imageAlt);
    }
  });

  if (window.Shopify.theme_settings.collection_swatches) {
    Theme.swatches.init();
  }

  if (window.Shopify.theme_settings.product_form_style == "dropdown") {
    var maxWidth = Math.max.apply(null, $('.multiple-options .selector-wrapper').map(function () {
      return $(this).outerWidth(true);
    }).get());
    $('.selector-wrapper').css('width', maxWidth + 'px');
  } //Remove product from cart page


  $('body').on("click", ".topBar__miniCart .cart__removeBtn", function (e) {
    e.preventDefault();
    var $this = $(this);
    var $cartCard = $this.parents('.cart_item');
    $cartCard.slideUp(function () {
      Theme.cart.ajaxUpdateCart($cartCard.data('line-id'), 0);
    });
  });
  $('.menu-link--false').on('click', function () {
    var checkbox = $(this).prev('.submenu--toggle');

    if (checkbox.prop('checked') == true) {
      checkbox.prop('checked', false);
    } else {
      checkbox.prop('checked', true);
    }
  });
  $('.recover-password').on('click', function (e) {
    e.preventDefault();
    $('#customer_login').hide();
    $('#recover-password').show();
  });
  $('.cancel-recover-password').on('click', function (e) {
    e.preventDefault();
    $('#customer_login').show();
    $('#recover-password').hide();
  }); //Disable body scrolling while mobile menu is overlaid

  $('.js-menu').click(function () {
    $('body').css('overflow-y', 'hidden');
  }); //Enable body scrolling when mobile menu is hidden

  $('.mobileMenu__close').click(function () {
    $('body').css('overflow-y', 'initial');
  });

  if (Theme.utils.is_touch_device()) {
    $('.mainMenu__link, .sublink.hasSubmenu').on('click', function (e) {
      if (!$(this).hasClass('clicked')) {
        e.preventDefault();
        $(this).addClass('clicked');
      }
    });
  } // Setup search dropdown focus


  $('.topBar__search').on('mouseenter', function () {
    $(this).find('.search__input').focus();
  });
  $('.topBar__search').on('mouseleave', function () {
    $(this).find('.search__input').blur();
  });
  var linkTarget = $('.js-navigation li a');
  linkTarget.mousedown(function () {
    $(this).data('mousedown', true);
  });
  linkTarget.focus(function (e) {
    if (!$(this).data('mousedown')) {
      $(this).parents('li.dropdown, .sub-menu').attr('aria-expanded', 'true').addClass('show-menu');
    }
  });
  linkTarget.blur(function () {
    $(this).data('mousedown', false);
    $('li.dropdown, .sub-menu').removeClass('show-menu').attr('aria-expanded', 'false');
  });
  $('.maps').click(function () {
    $('.maps iframe').css("pointer-events", "auto");
  });
  $('.searchForm .icon-search').on('click', function () {
    $('.searchForm').submit();
  }); //Terms of service settings

  if (window.Shopify.theme_settings.display_tos_checkbox && window.Shopify.theme_settings.go_to_checkout) {
    $('body').on('click touchstart', '.cart_content .tos_label', function () {
      $(this).prev('input').prop('checked', true);
    });
    $('.tos_agree').on('change', function () {
      if ($(this).is(':checked')) {
        $('.tos_agree').prop('checked', true);
      } else {
        $('.tos_agree').prop('checked', false);
      }
    });
    $('body').on('click', ".js-cart_content__form .action_button", function (e) {
      if ($(this).parents('form').find('.tos_agree').is(':checked')) {
        if (window.Shopify.theme_settings.go_to_checkout) {
          $(this).submit();
        } else {
          // Redirect to cart page
          e.preventDefault();
          document.location.href = "/cart";
        }
      } else {
        var warning = '<p class="warning animated bounceIn">' + window.Shopify.translation.agree_to_terms_warning + '</p>';

        if ($('p.warning').length == 0) {
          $('.miniCart__warningBox').html(warning);
        }

        return false;
      }
    });
    $('body').on('click', ".cart__checkout .action_button", function (e) {
      if ($(this).parents('form').find('.tos_agree').is(':checked')) {
        $(this).submit();
      } else {
        var warning = '<p class="warning animated bounceIn">' + window.Shopify.translation.agree_to_terms_warning + '</p>';

        if ($('p.warning').length == 0) {
          $('.cart__warningBox').html(warning);
        }

        return false;
      }
    });
  }

  if ($('[data-popup]').length) {
    Theme.newsletter_popup.init();
  } // Contact form checkbox validation


  if ($('[data-is-required]').length) {
    var $checkboxGroup = $('.checkbox');
    $checkboxGroup.prop('required', true);
    $('[data-is-required] .checkbox').on('change', function () {
      $checkboxGroup.prop('required', true);

      if ($checkboxGroup.is(":checked")) {
        $checkboxGroup.prop('required', false);
      }
    });
  }

  $(window).resize(function () {
    var resizeTimer = setTimeout(Theme.utils.resizeFunction(), 250);
    clearTimeout(resizeTimer);

    if ($('.gallery').hasClass('js-gallery')) {
      Theme.galleryPage.init();
    }
  });
}); //End of doc ready

/*============================================================================
  Responsive media
==============================================================================*/

function enableResponsiveVideoWrapper() {
  // Wraps YouTube and Vimeo iframes in Plyr wrapper
  // Does not target iframes already embedded in Plyr wrapper (video sections and product galleries)
  $('iframe[src*="youtube.com"]:not(.plyr__video-wrapper iframe[src*="youtube.com"])').wrap('<div class="plyr__video-embed"></div>');
  $('iframe[src*="vimeo.com"]:not(.plyr__video-wrapper iframe[src*="vimeo.com"])').wrap('<div class="plyr__video-embed"></div>');
}
/*============================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
==============================================================================*/


Shopify.updateOptionsInSelector = function (selectorIndex, parent) {
  switch (selectorIndex) {
    case 0:
      var key = 'root';
      var selector = $(parent + ' .single-option-selector:eq(0)');
      break;

    case 1:
      var key = $(parent + ' .single-option-selector:eq(0)').val();
      var selector = $(parent + ' .single-option-selector:eq(1)');
      break;

    case 2:
      var key = $(parent + ' .single-option-selector:eq(0)').val();
      key += ' / ' + $(parent + ' .single-option-selector:eq(1)').val();
      var selector = $(parent + ' .single-option-selector:eq(2)');
  }

  var availableOptions = Shopify.optionsMap[key];
  $(parent + ' .swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function () {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled', 'disabled').removeAttr('checked');
    } else {
      $(this).addClass('soldout').find(':radio').removeAttr('checked').attr('disabled', 'disabled');
    }
  });
  selector.trigger('change');
};

window.Shopify.linkOptionSelectors = function (product, parent) {
  // Building our mapping object.
  Shopify.optionsMap = {};

  for (var i = 0; i < product.variants.length; i++) {
    var variant = product.variants[i];

    if (variant.available) {
      // Gathering values for the 1st drop-down.
      Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
      Shopify.optionsMap['root'].push(variant.option1);
      Shopify.optionsMap['root'] = window.Shopify.uniq(Shopify.optionsMap['root']); // Gathering values for the 2nd drop-down.

      if (product.options.length > 1) {
        var key = variant.option1;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option2);
        Shopify.optionsMap[key] = window.Shopify.uniq(Shopify.optionsMap[key]);
      } // Gathering values for the 3rd drop-down.


      if (product.options.length === 3) {
        var key = variant.option1 + ' / ' + variant.option2;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option3);
        Shopify.optionsMap[key] = window.Shopify.uniq(Shopify.optionsMap[key]);
      }
    }
  } // Update options right away.


  Shopify.updateOptionsInSelector(0, parent);
  if (product.options.length > 1) Shopify.updateOptionsInSelector(1, parent);
  if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent); // When there is an update in the first dropdown.

  $(parent + " .single-option-selector:eq(0)").change(function () {
    Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
    return true;
  }); // When there is an update in the second dropdown.

  $(parent + " .single-option-selector:eq(1)").change(function () {
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
};

$(document).on('shopify:block:select', function (e) {
  var $target = $(e.target);
  var blockId = e.detail.blockId;
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);

  if ($parentSection.hasClass('shopify-section--slideshow')) {
    sliderBlock.select($parentSection, blockId);
  }

  if ($parentSection.hasClass('shopify-section--testimonials')) {
    sliderBlock.select($parentSection, blockId);
  }

  if ($parentSection.hasClass('page-details-section')) {
    if ($('.video-wrapper').length) {
      Theme.videoSection.init($target);
    }

    if ($('.shopify-section--map').length) {
      Theme.map.init();
    }
  }

  if ($parentSection.hasClass('pricing-table-section')) {
    $parentSection.find('.header--' + blockId).trigger('click');
  }

  if ($parentSection.hasClass('shopify-section--product-details-template')) {
    if ($('.video-wrapper').length) {
      Theme.videoSection.init();
    }

    if ($('.shopify-section--map').length) {
      Theme.map.init();
    }
  }
});
$(document).on('shopify:block:deselect', function (e) {
  var $target = $(e.target);
  var blockId = e.detail.blockId;
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);

  if ($parentSection.hasClass('shopify-section--slideshow')) {
    sliderBlock.deselect($parentSection, blockId);
  }

  if ($parentSection.hasClass('shopify-section--testimonials')) {
    sliderBlock.deselect($parentSection, blockId);
  }
});
$(document).on('shopify:section:reorder', function (e) {
  var $target = $(e.target);
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
});
$(document).on('shopify:section:load', function (e) {
  var $target = $(e.target);
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
  Theme.loadSectionScripts($parentSection);
  Theme.utils.enableDisclosure();

  if ($parentSection.hasClass('recommended-products-section')) {
    Theme.productPage.loadProductRecommendations();
  }

  if (window.Shopify.theme_settings.enable_autocomplete) {
    searchAutocomplete.init();
  }
});
$(document).on('shopify:section:unload', function (e) {
  var $target = $(e.target);
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
  Theme.utils.unload($target);

  if ($parentSection.hasClass('header-section')) {
    Theme.header.unload($target);
  }

  if ($parentSection.hasClass('password-page')) {
    Theme.password.unload();
  }

  if ($parentSection.hasClass('shopify-section--slideshow')) {
    Theme.slideshow.unload($target);
  }

  if ($parentSection.hasClass('shopify-section--testimonials')) {
    Theme.testimonials.unload($target);
  }

  if ($parentSection.hasClass('pricing-table-section')) {
    Theme.pricingTable.unload($target);
  }

  if ($parentSection.hasClass('collection-template-section')) {
    Theme.collection.unload($target);
  }

  if ($parentSection.hasClass('shopify-section--product-template')) {
    Theme.productPage.unload($target);
  }

  if ($parentSection.hasClass('shopify-section--featured-product')) {
    Theme.productPage.unload($target);
  }

  if ($parentSection.hasClass('page-details-section')) {
    if ($('.featuredProduct').length) {
      Theme.productPage.unload($target);
    }
  }

  if ($parentSection.hasClass('shapesOption')) {
    Theme.shapes.unload($target);
  }
});
$(document).on('shopify:section:select', function (e) {
  var $target = $(e.target);
  var $parentSection = $('#shopify-section-' + e.detail.sectionId); //Enable plyr

  videoFeature.init();

  if ($('[class^="shopify-product-reviews"]').length) {
    if (window.Shopify.theme_settings.enable_shopify_review_comments) {
      Theme.utils.renderReviews();
    }
  }

  if ($parentSection.hasClass('shopify-section--video')) {
    Theme.videoSection.init($target);
  }

  if ($parentSection.hasClass('shopify-section--featured-product') || $parentSection.hasClass('shopify-section--featured-collection ')) {
    Theme.productPage.init();
  }

  if ($parentSection.hasClass('collection-template-section')) {
    Theme.collection.init();

    if (window.Shopify.theme_settings.enable_shopify_collection_badges && window.Shopify.theme_settings.enable_shopify_review_comments) {
      Theme.utils.renderReviews();
    }
  }

  if ($parentSection.hasClass('shopify-section--slideshow')) {
    Theme.slideshow.init();
  }

  if ($parentSection.hasClass('shopify-section--testimonials')) {
    Theme.testimonials.init();
  }

  if ($parentSection.hasClass('image-gallery-section')) {
    Theme.galleryPage.enableGrid();
  }

  if ($parentSection.hasClass('popup-section')) {
    Theme.newsletter_popup.open('editor');
  }
});
$(document).on('shopify:section:deselect', function (e) {
  var $target = $(e.target);
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);

  if ($parentSection.hasClass('popup-section')) {
    Theme.newsletter_popup.close();
  }
});
$(document).on('shopify:block:load', function (e) {
  var $target = $(e.target);
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);

  if ($('.video-wrapper').length) {
    Theme.videoSection.init();
  }
});
}();
/******/ })()
;